import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Updated: 2025-01-30 - Service descriptions updated
const resources = {
  es: {
    translation: {
      // Navigation & Common
      "language": "Idioma",
      "admin_login": "Acceso Admin",
      "logout": "Cerrar Sesión",
      "get_started": "Comenzar",
      "learn_more": "Saber Más",
      "back_to_home": "Volver al Inicio",
      "loading": "Cargando...",
      "authenticating": "Autenticando...",
      "please_wait": "Por favor espera mientras te conectamos.",
      "success": "¡Éxito!",
      "redirecting": "Redirigiendo al panel...",
      
      // Landing Page
      "professional_car": "Transporte Profesional",
      "transfer_service": "de Vehículos",
      "landing_description": "Servicios de transporte de vehículos seguros, confiables y eficientes en toda Europa. Elige entre entregas estándar, servicios B-C o opciones de intercambio con precios transparentes basados en distancia.",
      "realtime_tracking": "Seguimiento en Tiempo Real",
      "realtime_desc": "Monitorea tu transporte de vehículo en cada paso",
      "flexible_timing": "Horarios Flexibles",
      "flexible_desc": "Establece márgenes de tiempo para recogida y entrega",
      "secure_payment": "Pago Seguro",
      "secure_desc": "Transacciones seguras vía pasarela Redsys",
      "clear_pricing": "Precios Claros",
      "clear_desc": "Tarifas basadas en distancia mostradas desde el inicio",
      "why_choose_us": "¿Por Qué Elegirnos?",
      "professional_service": "Servicio profesional en el que puedes confiar",
      "professional_drivers": "Conductores Profesionales",
      "drivers_desc": "Nuestros conductores experimentados y verificados aseguran que tu vehículo esté en buenas manos durante todo el viaje.",
      "fully_insured": "Completamente Asegurado",
      "insured_desc": "Cobertura de seguro completa para tu tranquilidad durante todo el proceso de transporte.",
      "transparent_pricing": "Precios Transparentes",
      "transparent_desc": "Sin tarifas ocultas. Precios claros basados en distancia calculados antes de reservar.",
      
      // Dashboard
      "client_portal": "Portal de Cliente",
      "my_orders": "Mis Servicios",
      "manage_orders": "Gestiona tus solicitudes de transporte de vehículos",
      "create_order": "Crear Servicio",
      "no_orders_yet": "Aún no hay servicios",
      "create_first_order": "Crea tu primer servicio de transporte de vehículo para comenzar",
      "search_by_plate": "Buscar por Matrícula",
      "enter_plate_number": "Ingresa el número de matrícula...",
      "no_orders_found": "No se encontraron servicios",
      "try_different_search": "Intenta con una búsqueda diferente",
      "try_different_filters": "Intenta ajustar los filtros de búsqueda",
      "filter_orders": "Filtrar Servicios",
      "filter_description": "Usa los filtros para encontrar servicios específicos",
      "filter_by_city": "Filtrar por Ciudad",
      "all_cities": "Todas las Ciudades",
      "date_from": "Fecha Desde",
      "date_to": "Fecha Hasta",
      "select_date": "Seleccionar fecha",
      "clear_filters": "Limpiar Filtros",
      "all": "Todos",
      "order_status": "Estado del Servicio",
      "point_c_required": "Dirección del Punto C requerida",
      "point_c_information": "Información del Punto C (Segunda Entrega)",
      "point_c_address": "Dirección del Punto C",
      "first_vehicle": "Primer Vehículo",
      "second_vehicle": "Segundo Vehículo",
      "bc_service_note": "Se recoge el primer coche en A, se entrega en B. Luego se recoge el segundo coche en B y se entrega en C.",
      "tradein_note": "Se recoge el primer coche en A, se entrega en B. Luego se recoge el segundo coche en B y se entrega en A.",
      "edit_order": "Editar Servicio",
      "cancel_order": "Cancelar Servicio",
      "show_more": "Ver más",
      "show_less": "Ver menos",
      "dashboard": "Panel Principal",
      "my_services": "Mis Servicios",
      "create_service": "Crear Servicio",
      "my_company": "Mi Empresa",
      "company_profile": "Perfil Empresarial",
      "statistics": "Estadísticas",
      "total_services": "Total de Servicios",
      "in_progress": "En Proceso",
      "completed": "Completados",
      "cancelled": "Cancelados",
      "pending_payment": "Pagos Pendientes",
      "total_spent": "Total Gastado",
      "recent_services": "Servicios Recientes",
      "upcoming_services": "Próximos Servicios",
      
      // Profile/Company
      "company_information": "Información de Empresa",
      "company_name": "Nombre de Empresa",
      "company_name_required": "Nombre de Empresa *",
      "company_logo": "Logo de Empresa",
      "upload_logo": "Subir Logo",
      "change_logo": "Cambiar Logo",
      "contact_person": "Persona de Contacto",
      "contact_person_required": "Persona de Contacto *",
      "cif_dni": "CIF/DNI",
      "cif_dni_required": "CIF/DNI *",
      "cif_dni_placeholder": "Ej: B12345678 o 12345678A",
      "phone_number": "Teléfono",
      "phone_required": "Teléfono *",
      "company_address": "Dirección",
      "address_placeholder": "Dirección completa de la empresa",
      "contact_information": "Información de Contacto",
      "company_logo_desc": "Sube el logo de tu empresa para personalizar tu perfil",
      "company_info_billing_desc": "Información empresarial y de facturación",
      "contact_data_desc": "Datos de la persona de contacto",
      "email_readonly_note": "El email no se puede modificar",
      "change_password_section_desc": "Actualiza tu contraseña de acceso",
      "email_address": "Correo electrónico",
      "client_no_invoices": "No hay facturas disponibles",
      "client_invoices_biweekly": "Las facturas se generan automáticamente cada 15 días",
      "client_invoices_ondemand": "Los pagos se procesan al momento de crear servicios",
      "client_address_required": "Dirección *",
      "client_verification_date": "Fecha de Verificación *",
      "client_verification_time": "Hora de Verificación *",
      "client_verification_time_from": "Hora de Verificación - Desde *",
      "client_verification_time_to": "Hora de Verificación - Hasta *",
      "client_fixed_datetime": "Fecha y Hora Fija",
      "client_range_datetime": "Rango de Fecha y Hora",
      "client_switch_to_range": "Cambiar a Rango",
      "client_switch_to_fixed": "Cambiar a Fecha Fija",
      "client_select_date": "Selecciona fecha",
      "client_address_heading": "Dirección",
      "client_time_from": "Desde",
      "client_time_to": "Hasta",
      "service_not_found": "Servicio no encontrado",
      "no_driver_assigned": "Sin asignar",
      "address_not_specified": "Dirección no especificada",
      "no_plate": "Sin matrícula",
      "car_type_turismo": "Turismo",
      "back_to_dashboard": "Volver al Dashboard",
      "client_financial_summary_desc": "Resumen de pagos y facturación",
      "client_pending_services_label": "servicios pendientes",
      "client_last_5_services": "Últimos 5 servicios solicitados",
      "client_pickup_label": "Recogida:",
      "client_delivery_label": "Entrega:",
      "client_no_recent_services": "No hay servicios recientes",
      "client_create_first_service": "Crea tu primer servicio para empezar",
      "billing_information": "Información de Facturación",
      "security": "Seguridad",
      "change_password": "Cambiar Contraseña",
      "current_password": "Contraseña Actual",
      "new_password": "Nueva Contraseña",
      "confirm_password": "Confirmar Contraseña",
      "password_requirements": "Mínimo 8 caracteres",
      "save_changes": "Guardar Cambios",
      "profile_updated": "Perfil actualizado correctamente",
      "profile_update_error": "Error al actualizar el perfil",
      "password_updated": "Contraseña actualizada correctamente",
      "password_update_error": "Error al actualizar la contraseña",
      "passwords_dont_match": "Las contraseñas no coinciden",
      "welcome": "Bienvenido",
      "services_by_status": "Servicios por Estado",
      "services_by_type": "Servicios por Tipo",
      "financial_summary": "Resumen Financiero",
      "view_invoices": "Ver Facturas",
      "member_since": "Miembro desde",
      "quick_actions": "Acciones Rápidas",
      "cancellation_policy": "Política de Cancelaciones y Modificaciones",
      "cancel_policy_1": "• Cancelaciones en la primera hora: Sin coste",
      "cancel_policy_2": "• Cancelaciones entre 1 hora y 24 horas antes: 50% del precio",
      "cancel_policy_3": "• Cancelaciones con menos de 24 horas: 100% del precio",
      "cancel_policy_4": "• Modificaciones de ubicación después de 1 hora: 20€",
      "cancel_policy_5": "• Cambios en primera hora: Gratis",
      "cancel_policy_6": "• Cambios durante transporte: 50€ + 0.33€/km",
      "cancel_policy_7": "• Cambios dentro de 24h previas: 20€ + 0.26€/km",
      "cancel_policy_8": "• Cancelación durante transporte: Se cobra como completado",
      "cancel_policy_9": "• Si el vehículo no está disponible: Se cobra como completado",
      "confirm_cancel": "¿Estás seguro que quieres cancelar este servicio?",
      "order_cancelled": "Servicio cancelado exitosamente",
      "order_updated": "Servicio actualizado exitosamente",
      
      // Order Form
      "create_new_order": "Crear Nuevo Servicio de Transporte",
      "fill_details": "Completa los detalles de tu solicitud de transporte de vehículo",
      "service_type": "Tipo de Servicio",
      "service_type_required": "Selecciona un tipo de servicio *",
      "delivery": "Entrega",
      "delivery_desc": "Transporte estándar de un solo vehículo del punto A al punto B.",
      "bc_service": "Servicio B-C",
      "bc_service_desc": "Múltiples Destinos: Recojo en A, entrego en B y recojo en B para entregar en C (20% de descuento en el 2do vehículo).",
      "tradein": "TRADE-IN",
      "tradein_desc": "Intercambio de Vehículos: Recojo en A, entrego en B y recojo en B para devolver en A (30% de descuento en el 2do vehículo).",
      "representacion": "Representación",
      "representacion_desc": "Verificación in situ",
      
      // Pickup Information
      "pickup_information": "Información de Recogida",
      "pickup_address": "Dirección de Recogida *",
      "start_typing_address": "Comienza a escribir la dirección...",
      "contact_name": "Nombre de Contacto *",
      "contact_phone": "Teléfono de Contacto *",
      "pickup_date_range": "Rango de Fechas de Recogida *",
      "select_dates": "Seleccionar fechas",
      "pickup_time": "Hora de Recogida *",
      "select_time": "Seleccionar hora",
      
      // Delivery Information
      "delivery_information": "Información de Entrega",
      "delivery_address": "Dirección de Entrega *",
      "delivery_date_range": "Rango de Fechas de Entrega *",
      "delivery_time": "Hora de Entrega *",
      
      // Vehicle Information
      "vehicle_information": "Información del Vehículo",
      "vehicle_type": "Tipo de Vehículo *",
      "select_vehicle_type": "Selecciona tipo de vehículo",
      "car": "Berlina",
      "van": "Furgoneta",
      "pickup_truck": "Camión < 3.500kg",
      "sport_car": "Deportivo",
      "suv": "SUV",
      "motorcycle": "Motocicleta",
      "brand": "Marca *",
      "model": "Modelo *",
      "license_plate": "Matrícula *",
      "fuel_type": "Tipo de Combustible *",
      "select_fuel_type": "Selecciona tipo de combustible",
      "electric": "Eléctrico",
      "hybrid": "Híbrido",
      "diesel": "Diésel",
      "gasoline": "Gasolina",
      
      // Second Vehicle
      "second_vehicle_optional": "Segundo Vehículo (Opcional)",
      "second_vehicle_desc": "Para servicios B-C o intercambio",
      "add_second_vehicle": "Agregar Segundo Vehículo",
      "remove_second_vehicle": "Eliminar Segundo Vehículo",
      
      // Representación fields
      "buyer_data": "Datos del Comprador",
      "seller_data": "Datos del Vendedor",
      "buyer_name": "Nombre del Comprador",
      "buyer_surname": "Apellidos del Comprador",
      "buyer_phone": "Teléfono del Comprador",
      "buyer_dni": "DNI/NIE del Comprador",
      "seller_name": "Nombre del Vendedor",
      "seller_surname": "Apellidos del Vendedor",
      "seller_phone": "Teléfono del Vendedor",
      "seller_dni": "DNI/NIE del Vendedor",
      "verification_address": "Dirección de Verificación",
      "verification_date": "Fecha de Verificación",
      "verification_time": "Hora de Verificación",
      "enter_verification_address": "Introduce la dirección donde se verificará el vehículo",
      
      // Additional Services
      "additional_services": "Servicios Adicionales",
      "select_additional_services": "Selecciona servicios adicionales si los necesitas",
      "exterior_cleaning": "Limpieza Exterior",
      "interior_cleaning": "Limpieza Interior",
      "waiting_period": "Período de Espera",
      "itv_inspection": "Inspección ITV",
      "pit_stop": "Parada en Taller",
      
      // Distance & Pricing
      "distance_pricing": "Distancia y Precios",
      "calculated_distance": "Distancia Calculada",
      "calculating": "Calculando...",
      "base_price": "Precio Base",
      "additional_services_total": "Total Servicios Adicionales",
      "total_price": "Precio Total",
      "notes": "Notas (Opcional)",
      "notes_placeholder": "Cualquier información adicional...",
      
      // Actions
      "cancel": "Cancelar",
      "create": "Crear",
      "update_order": "Guardar Cambios",
      "update": "Actualizar",
      "delete": "Eliminar",
      "edit": "Editar",
      "pay_now": "Pagar Ahora",
      "calculate_price": "Calcular Precio",
      
      // Order Status
      "status": "Estado",
      "pending": "Por Asignar",
      "confirmed": "Confirmado",
      "assigned": "Asignado",
      "in_transit": "En Tránsito",
      "delivered": "Completado",
      "cancelled": "Cancelados",
      "Cancelado en Garantía": "Cancelado en Garantía",
      "Cancelado con -24h antelación": "Cancelado con -24h antelación",
      "Cancelado con +24h de antelación": "Cancelado con +24h de antelación",
      "pending": "Pendiente",
      "paid": "Pagado",
      "failed": "Fallido",
      
      // Admin
      "admin_portal": "Portal de Administración",
      "dashboard": "Panel",
      "overview": "Resumen",
      "orders": "Servicios",
      "drivers": "Conductores",
      "pricing": "Precios",
      "total_orders": "Servicios Totales",
      "pending_orders": "Servicios Pendientes",
      "total_drivers": "Conductores Totales",
      "total_revenue": "Ingresos Totales",
      "recent_orders": "Servicios Recientes",
      "orders_management": "Gestión de Servicios",
      "drivers_management": "Gestión de Conductores",
      "pricing_management": "Gestión de Precios",
      "search_by_client": "Buscar por cliente",
      "search_by_plate": "Buscar por matrícula",
      "filter_by_status": "Filtrar por estado",
      "filter_by_city": "Filtrar por ciudad",
      "filter_by_date": "Filtrar por fecha",
      "from_date": "Desde fecha",
      "to_date": "Hasta fecha",
      "all_statuses": "Todos los estados",
      "all_cities": "Todas las ciudades",
      "update_order": "Actualizar Servicio",
      "edit_order_details": "Editar Detalles del Servicio",
      "assign_driver": "Asignar Conductor",
      "no_driver": "Sin conductor",
      "update": "Actualizar",
      "save_changes": "Guardar Cambios",
      "cancel": "Cancelar",
      "pickup_address": "Dirección de Recogida",
      "delivery_address": "Dirección de Entrega",
      "client_info": "Información del Cliente",
      "service_details": "Detalles del Servicio",
      "add_driver": "Añadir Conductor",
      "driver_name": "Nombre del Conductor",
      "driver_phone": "Teléfono del Conductor",
      "driver_status": "Estado del Conductor",
      "available": "Disponible",
      "busy": "Ocupado",
      "offline": "Desconectado",
      "add_pricing_rate": "Añadir Tarifa",
      "distance_range": "Rango de Distancia",
      "min_distance": "Distancia Mínima (km)",
      "max_distance": "Distancia Máxima (km)",
      "price_per_km": "Precio por km",
      "base_fee": "Tarifa Base",
      "example_price": "Precio de Ejemplo (100km)",
      "actions": "Acciones",
      "edit": "Editar",
      "delete": "Eliminar",
      "view_details": "Ver Detalles",
      "filters": "Filtros",
      "clear_filters": "Limpiar Filtros",
      "apply_filters": "Aplicar Filtros",
      "results": "resultados",
      "no_results": "No se encontraron resultados",
      "view_manage_orders": "Ver y gestionar todos los servicios de traslado",
      "pickup": "Recogida",
      "delivery": "Entrega",
      "vehicle": "Vehículo",
      "distance": "Distancia",
      "price": "Precio",
      "assigned_driver": "Conductor Asignado",
      "service_type": "Tipo de Servicio",
      "car_brand": "Marca",
      "car_model": "Modelo",
      "car_plate": "Matrícula",
      "fuel_type": "Tipo de Combustible",
      "pickup_contact": "Contacto de Recogida",
      "delivery_contact": "Contacto de Entrega",
      "contact_name": "Nombre de Contacto",
      "contact_phone": "Teléfono de Contacto",
      "pickup_date": "Fecha de Recogida",
      "delivery_date": "Fecha de Entrega",
      "no_delivery_date": "Sin fecha de entrega",
      "manage_driver_fleet": "Gestiona tu flota de conductores",
      "information": "Información",
      "modify_order_information": "Modifica la información del servicio",
      "payment_status": "Estado del Pago",
      "monitor_performance": "Monitorea el rendimiento de tu servicio de traslado",
      "client": "Cliente",
      "route": "Ruta",
      "service": "Servicio",
      "filter_by_payment": "Filtrar por estado del pago",
      "filter_by_driver": "Filtrar por conductor",
      "no_driver_assigned": "Sin conductor asignado",
      "all_drivers": "Todos los conductores",
      "search_driver": "Buscar conductor...",
      "create_new_driver": "Crear nuevo conductor",
      "type_to_search": "Escribe para buscar...",
      "driver_info": "Información del Conductor",
      "driver_phone": "Teléfono Conductor",
      "driver_dni": "DNI/NIF Conductor",
      
      // Admin Dashboard (sidebar, stats, kanban, sub-admins)
      "admin_calendar": "Calendario",
      "admin_management": "Gestión",
      "admin_pricing_section": "Tarifas",
      "admin_general_pricing": "Tarifas Generales",
      "admin_driver_pricing": "Tarifas Conductores",
      "admin_custom_pricing": "Tarifas Personalizadas",
      "admin_billing": "Facturación",
      "admin_client_invoices": "Facturas Clientes",
      "admin_driver_invoices": "Facturas Conductores",
      "admin_approvals": "Aprobaciones",
      "admin_administration": "Administración",
      "admin_profiles": "Perfiles",
      "admin_documents": "Documentos",
      "admin_collaborators": "Colaboradores",
      "admin_close_sidebar": "Cerrar menú",
      "admin_services_in_progress": "Servicios en Curso",
      "admin_total_services_done": "Servicios Totales Hechos",
      "admin_pending_closure": "Pendientes Cierre (Chóferes)",
      "admin_services_completed": "Servicios Completados",
      "admin_pending_payment": "Pendientes de Pago",
      "admin_services_paid": "Servicios Pagados",
      "admin_pending_approvals": "Aprobaciones Pendientes",
      "admin_total_revenue": "Ingresos Totales",
      "admin_kanban_new": "Nuevos",
      "admin_kanban_new_subtitle": "Sin conductor asignado",
      "admin_kanban_assigned": "Asignados",
      "admin_kanban_assigned_subtitle": "En ruta / En progreso",
      "admin_kanban_pending_approval": "Por Aprobar",
      "admin_kanban_pending_approval_subtitle": "Esperando validación",
      "admin_kanban_completed": "Completados",
      "admin_kanban_completed_subtitle": "Pendiente de histórico",
      "admin_no_client": "Sin cliente",
      "admin_unassigned": "Sin asignar",
      "admin_status_pending": "Pendiente",
      "admin_status_assigned": "Asignado",
      "admin_status_in_progress": "En Progreso",
      "admin_status_in_transit": "En Tránsito",
      "admin_status_delivered": "Entregado",
      "admin_status_cancelled": "Cancelado",
      "admin_payment_pending": "Pago Pendiente",
      "admin_payment_paid": "Pagado",
      "admin_payment_failed": "Pago Fallido",
      "admin_client_label": "Cliente:",
      "admin_driver_label": "Conductor:",
      "admin_price_client": "Precio Cliente:",
      "admin_price_driver": "Precio Conductor:",
      "admin_distance": "Distancia:",
      "admin_photos_pickup": "Fotos Recogida",
      "admin_photos_delivery": "Fotos Entrega",
      "admin_expenses": "Gastos",
      "admin_open": "Abrir",
      "admin_complete": "Completar",
      "admin_history": "Historial",
      "admin_revert": "Revertir",
      "admin_revert_title": "Devolver a En Proceso para modificar gastos",
      "admin_photos": "Fotos",
      "admin_contract": "Contrato",
      "admin_calendar_btn": "Calendar",
      "admin_delete": "Eliminar",
      "admin_cancel": "Cancelar",
      "admin_cancel_at_pickup": "Salida",
      "admin_cancel_at_pickup_title": "Vehículo no disponible en recogida",
      "admin_cancel_in_transit": "Transporte",
      "admin_cancel_in_transit_title": "Cancelado durante transporte",
      "admin_approve_cancellation": "Aprobar Cancelación",
      "admin_filters": "Filtros",
      "admin_filter_client": "Cliente",
      "admin_search_client_placeholder": "Buscar cliente...",
      "admin_plate": "Matrícula",
      "admin_plate_placeholder": "Matrícula...",
      "admin_city": "Ciudad",
      "admin_city_placeholder": "Ciudad...",
      "admin_driver_filter": "Conductor",
      "admin_from": "Desde",
      "admin_to": "Hasta",
      "admin_clear_filters": "Limpiar",
      "admin_all": "Todos",
      "admin_kanban_tip": "Arrastra las tarjetas entre columnas para cambiar el estado del servicio",
      "admin_services_in_process": "servicios en proceso",
      "admin_drop_here": "Soltar aquí",
      "admin_no_services": "No hay servicios",
      "admin_confirm_action": "Confirmar Acción",
      "admin_approve_service": "Aprobar Servicio",
      "admin_approve_service_message": "¿Confirmas que deseas aprobar el servicio #{{id}}? El servicio pasará a estado Completado.",
      "admin_revert_state": "Revertir Estado",
      "admin_revert_state_message": "¿Deseas mover el servicio #{{id}} de vuelta a \"{{target}}\"? Esto abrirá el diálogo de edición para hacer los cambios necesarios.",
      "admin_confirm": "Confirmar",
      "admin_subadmins_title": "Gestión de Colaboradores",
      "admin_subadmins_desc": "Crea y administra usuarios con acceso limitado al sistema",
      "admin_new_collaborator": "Nuevo Colaborador",
      "admin_what_is_collaborator": "¿Qué es un Colaborador?",
      "admin_collaborator_bullet1": "Solo puede ver los conductores y servicios que tú le asignes",
      "admin_collaborator_bullet2": "Puede asignar tarifas solo a los conductores que gestiona",
      "admin_collaborator_bullet3": "Por defecto, no puede ver precios de clientes ni eliminar nada",
      "admin_collaborator_bullet4": "Puede crear nuevos servicios y gestionar fotos/documentos de sus conductores",
      "admin_loading_collaborators": "Cargando colaboradores...",
      "admin_no_collaborators": "No hay colaboradores creados",
      "admin_create_first_collaborator": "Crea un nuevo colaborador para empezar",
      "admin_see_prices": "Ve precios clientes",
      "admin_no_see_prices": "No ve precios clientes",
      "admin_see_unassigned": "Ve sin asignar",
      "admin_no_see_unassigned": "No ve sin asignar",
      "admin_can_delete": "Puede eliminar",
      "admin_cannot_delete": "No puede eliminar",
      "admin_drivers_count": "conductores",
      "admin_services_count": "servicios",
      "admin_assigned_drivers": "Conductores asignados:",
      "admin_assigned_services_unassigned": "Servicios asignados (sin conductor):",
      "admin_edit": "Editar",
      "admin_services": "Servicios",
      "admin_create_collaborator": "Crear Nuevo Colaborador",
      "admin_name_required": "Nombre *",
      "admin_name_placeholder": "Nombre del colaborador",
      "admin_email_required": "Email *",
      "admin_email_placeholder": "colaborador@empresa.com",
      "admin_password_required": "Contraseña *",
      "admin_password_placeholder": "Mínimo 8 caracteres",
      "admin_admin_type": "Tipo de Admin",
      "admin_permissions": "Permisos",
      "admin_can_see_prices_invoices": "Puede ver precios, tarifas y facturas de clientes",
      "admin_includes_prices_note": "Incluye: Tarifas, Facturas Clientes, Perfiles, columna de precios",
      "admin_can_see_unassigned_services": "Puede ver servicios sin asignar",
      "admin_can_delete_services": "Puede eliminar servicios y conductores",
      "admin_assigned_drivers_required": "Conductores Asignados *",
      "admin_all_drivers": "Todos",
      "admin_none": "Ninguno",
      "admin_search_driver_placeholder": "Buscar conductor...",
      "admin_no_drivers_available": "No hay conductores disponibles",
      "admin_drivers_selected": "conductor(es) seleccionado(s)",
      "admin_create_collaborator_btn": "Crear Colaborador",
      "admin_edit_collaborator": "Editar Colaborador",
      "admin_email_readonly": "El email no se puede cambiar",
      "admin_save_changes": "Guardar Cambios",
      "admin_assign_services_to": "Asignar Servicios a",
      "admin_assign_services_note": "Solo se muestran servicios sin conductor asignado. Los servicios con conductor asignado se filtran automáticamente por los conductores del colaborador.",
      "admin_search_service_placeholder": "Buscar por ciudad, cliente o ID...",
      "admin_no_unassigned_services": "No hay servicios sin conductor disponibles",
      "admin_services_selected": "servicio(s) seleccionado(s)",
      "admin_save_services": "Guardar Servicios",
      "admin_super_admin": "Administrador Principal",
      "admin_full": "Admin Completo",
      "admin_sub_admin": "Colaborador",
      "admin_sub_admin_option": "Colaborador (Acceso limitado)",
      "admin_full_option": "Admin Completo (Ve todo)",
      "admin_driver_not_found": "Conductor no encontrado",
      "admin_service_not_found": "Servicio no encontrado",
      "admin_error_load_collaborators": "Error al cargar colaboradores",
      "admin_error_create_collaborator": "Error al crear colaborador",
      "admin_error_update_collaborator": "Error al actualizar colaborador",
      "admin_error_delete_collaborator": "Error al eliminar colaborador",
      "admin_error_assign_services": "Error al asignar servicios",
      "admin_confirm_delete_collaborator": "¿Estás seguro de eliminar este colaborador?",
      "admin_fill_required": "Por favor completa todos los campos obligatorios",
      "admin_assign_at_least_one_driver": "Debes asignar al menos un conductor al colaborador",
      "admin_charge_espera": "Espera",
      "admin_charge_pit_stop": "Pit Stop",
      "admin_charge_itv": "ITV",
      "admin_charge_express": "Express",
      "admin_charge_recogida_extra": "Recogida Extra",
      "admin_charge_cambio_ruta": "Cambio de Ruta",
      "admin_charge_otros": "Otros",
      "admin_toast_periods_generated": "Periodos generados correctamente",
      "admin_toast_error_load_periods": "Error al cargar periodos de facturación",
      "admin_toast_error_generate_periods": "Error al generar periodos de facturación",
      "admin_toast_error_create_invoice": "Error al crear factura",
      "admin_toast_service_marked_paid": "Servicio marcado como pagado",
      "admin_toast_error_mark_paid": "Error al marcar servicio como pagado",
      "admin_toast_invoice_marked_paid": "Factura marcada como pagada",
      "admin_toast_error_invoice_paid": "Error al marcar factura como pagada",
      "admin_toast_collaborator_created": "Colaborador creado correctamente",
      "admin_toast_collaborator_created_no_email": "Colaborador creado. No se pudo enviar el email; comparte las credenciales manualmente.",
      "admin_toast_collaborator_updated": "Colaborador actualizado correctamente",
      "admin_toast_collaborator_deleted": "Colaborador eliminado correctamente",
"admin_toast_services_assigned": "Servicios asignados correctamente",
      "admin_table_service_id": "Servicio ID",
      "admin_table_client": "Cliente",
      "admin_table_plate": "Matrícula",
      "admin_table_pickup": "Recogida",
      "admin_table_delivery": "Entrega",
      "admin_table_dates": "Fechas",
      "admin_table_driver": "Conductor",
      "admin_table_status": "Estado",
      "admin_table_price": "Precio",
      "admin_table_action": "Acción",
      "calendar_title": "Calendario de Servicios",
      "calendar_subtitle": "Todos los servicios organizados por fecha de recogida",
      "calendar_no_driver": "Sin conductor",
      "calendar_in_progress": "En proceso",
      "calendar_completed": "Completado",
      "calendar_others": "Otros",
      "calendar_origin": "Origen:",
      "calendar_destination": "Destino:",
      "calendar_driver": "Conductor:",
      "calendar_client": "Cliente:",
      "calendar_price": "Precio:",
      "timezone_label": "Zonas horarias (para alinear agenda)",
      "timezone_configure": "Configurar",
      "timezone_zone1_label": "Etiqueta zona 1 (ej. Yo, Madrid, Cliente)",
      "timezone_zone2_label": "Etiqueta zona 2 (ej. Asistente, Bangkok, Equipo)",
      "timezone_zone1_placeholder": "Zona 1",
      "timezone_zone2_placeholder": "Zona 2",
      "timezone_search_placeholder": "Buscar zona...",
      "timezone_help": "Las horas del calendario se muestran en ambas zonas. Elige cualquier par de zonas (p. ej. tú y tu asistente) para alinear agendas.",
      "timezone_save": "Guardar",
      "admin_services_in_progress_tab": "En proceso",
      "admin_historical": "Histórico",
      "admin_list": "Lista",
      "admin_creation": "Creación:",
      "admin_rate_assigned_driver": "Tarifa asignada al conductor:",
      "admin_rate_suggestions_driver": "Sugerencias de Tarifa para Conductor:",
      "admin_rate_for_driver_incomplete": "Tarifas para Conductor (completa distancia y tipo):",
      "admin_basic": "Básica",
      "admin_active": "Activa",
      "admin_custom": "A medida",
      "admin_customized": "Personalizada",
      "admin_approve": "Aprobar",
      "admin_complete_service_title": "Completar servicio con fotos y gastos",
      "admin_delete_service_title": "Eliminar servicio permanentemente",
      "admin_view_history_title": "Ver detalles del servicio completado",
      "admin_cancel_normal_title": "Cancelación normal (según tiempo)",
      "admin_calculated_distance": "Distancia Calculada",
      "admin_not_calculated": "No calculada",
      "admin_additional_services": "Servicios Adicionales",
      "admin_service_notes": "Notas del Servicio",
      "admin_notes_general": "General:",
      "admin_notes_vehicle1": "Vehículo 1:",
      "admin_notes_vehicle2": "Vehículo 2:",
      "admin_view_photos": "Ver Fotos",
      "admin_view_expenses": "Ver Gastos",
      "admin_no_photos_for_service": "No hay fotos disponibles para este servicio.",
      "admin_no_expenses_for_service": "No hay gastos reportados para este servicio.",
      "admin_service_expenses": "Gastos del Servicio",
      "admin_close": "Cerrar",
      "admin_no_receipts_attached": "No se adjuntaron recibos con este reporte",
      "admin_table_name": "Nombre",
      "admin_table_phone": "Teléfono",
      "admin_table_email": "Email",
      "admin_table_license": "Licencia",
      "admin_table_actions": "Acciones",
      "admin_driver_status_required": "Estado *",
      "admin_driver_busy": "Ocupado",
      "admin_driver_offline": "Desconectado",
      "admin_toast_driver_created_ok": "Conductor creado correctamente.",
      "admin_toast_driver_docs_uploaded": "{{count}} documento(s) subido(s).",
      "admin_toast_driver_welcome_email_sent": "Email de bienvenida enviado.",
      "admin_service_expenses_subtitle": "Servicio #{{id}} - {{brand}} {{model}}",
      "admin_add_to_calendar": "Agregar a Calendar",
      "admin_download_contract": "Descargar Contrato",
      "admin_premium": "Premium",
      "admin_toast_opening_calendar": "Abriendo Google Calendar...",
      "admin_toast_contract_downloaded": "Contrato descargado - 2 páginas: Conductor y Cliente",
      "admin_toast_error_generate_contract": "Error al generar el contrato",
      "admin_toast_error_download_contract": "Error al descargar el contrato",
      "pagination_showing": "Mostrando",
      "pagination_to": "a",
      "pagination_of": "de",
      "pagination_results": "resultados",
      "pagination_prev": "Anterior",
      "pagination_next": "Siguiente",
      "pagination_page_of": "Página {{current}} de {{total}}",
      "driver_profile_title": "Perfil del Conductor",
      "driver_profile_subtitle": "Información detallada, documentos y estadísticas",
      "driver_basic_info": "Información Básica",
      "driver_upload_new": "Subir Nuevo",
      "driver_upload_new_document": "Subir Nuevo Documento",
      "driver_statistics": "Estadísticas",
      "driver_total_services": "Servicios Totales",
      "driver_completed": "Completados",
      "driver_earnings": "Ganancias",
      "driver_billing_info": "Información de Facturación",
      "driver_doc_not_uploaded": "No subido",
      "driver_doc_expires_soon": "Vence Pronto",
      "driver_doc_approved": "Aprobado",
      "driver_doc_pending": "Pendiente",
      "driver_doc_rejected": "Rechazado",
      "driver_doc_expired": "Expirado",
      "driver_doc_dni_front": "DNI - Frente",
      "driver_doc_dni_back": "DNI - Reverso",
      "driver_doc_license_front": "Licencia - Frente",
      "driver_doc_license_back": "Licencia - Reverso",
      "driver_doc_autonomo": "Certificado Autónomo",
      "driver_doc_hacienda": "Certificado Hacienda",
      "driver_doc_ss": "Seguridad Social",
      "driver_error_open_document": "Error al abrir el documento",
      "driver_validated": "Validado",
      "driver_subidos_required": "subidos de {{required}} requeridos",
      "admin_edit_driver": "Editar Conductor",
      "admin_edit_driver_description": "Modifica la información del conductor. El admin puede editar todo.",
      "admin_label_name": "Nombre",
      "admin_label_email": "Correo electrónico",
      "admin_label_phone": "Teléfono",
      "admin_label_dni_nif": "DNI/NIF",
      "admin_driver_available": "Conductor disponible",
      "admin_documents_validated": "Documentos Validados",
      "admin_billing_full_name": "Nombre y Apellidos Completos *",
      "admin_billing_legal_name_hint": "Nombre legal completo para facturas",
      "admin_billing_dni_nie": "DNI o NIE *",
      "admin_billing_irpf": "Retención IRPF (%)",
      "admin_billing_irpf_hint": "Porcentaje de IRPF a retener (0-100%)",
      "admin_billing_fiscal_address": "Dirección Fiscal Completa *",
      "admin_billing_bank_name": "Nombre del Banco *",
      "admin_billing_iban": "Número de Cuenta (IBAN) *",
      "admin_driver_type": "Tipo de Conductor",
      "admin_fleet_driver": "Conductor con Flota",
      "admin_fleet_driver_hint": "Los conductores con flota pueden crear y gestionar otros conductores bajo su supervisión.",
      "admin_assign_fleet": "Asignar a Flota (Opcional)",
      "admin_independent_driver": "Conductor Independiente",
      "admin_fleet_assign_hint": "Si seleccionas una flota, este conductor estará bajo la supervisión del conductor con flota seleccionado",
      "admin_add_new_driver": "Añadir Nuevo Conductor",
      "admin_enter_driver_info": "Introduce los datos del conductor",
      "admin_license_number": "Número de Licencia",
      "admin_name_label": "Nombre",
      "admin_vehicle_info_label": "Información del Vehículo",
      "admin_drivers_management": "Gestión de Conductores",
      "admin_manage_driver_fleet": "Gestiona tu flota de conductores",
      "admin_clients_management": "Gestión de Clientes",
      "admin_clients_detail": "Información detallada de todos los clientes",
      "admin_drivers_detail": "Información detallada de todos los conductores",
      "admin_drivers_assigned_desc": "Conductores que tienes asignados o que has creado",
      "admin_drivers_assigned": "Asignados",
      "admin_drivers_registered": "Registrados",
      "admin_drivers_assigned_title": "Conductores Asignados",
      "admin_drivers_registered_title": "Conductores Registrados",
      "admin_create_driver": "Crear Conductor",
      "admin_billing_info": "Información de Facturación",
      "admin_delivery_info": "Información de Entrega",
      "admin_driver_docs_title": "Documentación del Conductor",
      "admin_validation_pending": "Pendiente Validación",
      "admin_docs_warning_title": "Atención: Conductor validado sin documentos",
      "admin_docs_warning_body": "Este conductor está marcado como \"Validado\" pero no tiene ningún documento subido al sistema. Por favor, sube los documentos correspondientes para mantener los registros correctos.",
      "admin_fleet_driver_info": "Conductor de Flota: Solo requiere Licencia de Conducir y DNI (4 documentos básicos)",
      "admin_independent_driver_info": "Conductor Independiente/Flotista: Requiere todos los documentos (7 en total)",
      "admin_docs_upload_note": "Al subir documentos como admin, se validan automáticamente. Máximo 5MB por archivo.",
      "admin_docs_uploaded_count": "Documentos Subidos ({{count}})",
      "admin_docs_basic": "Documentos Básicos (Obligatorios)",
      "admin_docs_certificates": "Certificados Adicionales (Solo Independientes y Flotistas)",
      "admin_expiry_date": "Fecha de Vencimiento",
      "admin_format_image_pdf": "Formato: JPG, PNG o PDF (máx. 5MB)",
      "admin_format_pdf": "Formato: PDF (máx. 5MB)",
      "admin_uploaded": "Subido",
      "admin_expires": "Vence",
      "admin_expired": "VENCIDO",
      "admin_expires_soon": "VENCE PRONTO",
      "admin_docs_no_delete": "Los documentos NO pueden ser borrados. Para reemplazar un documento, sube uno nuevo del mismo tipo.",
      "admin_uploading_doc": "Subiendo documento...",
      "admin_doc_license_front_full": "Licencia de Conducir (Frontal)",
      "admin_doc_license_back_full": "Licencia de Conducir (Trasera)",
      "admin_doc_dni_front_full": "DNI/NIE (Frontal)",
      "admin_doc_dni_back_full": "DNI/NIE (Trasero)",
      "admin_doc_autonomo_full": "Alta de Autónomo",
      "admin_doc_ss_full": "Certificado Corriente Seguridad Social",
      "admin_doc_hacienda_full": "Certificado Corriente Agencia Tributaria",
      "admin_general_pricing_title": "Tarifas Generales Clientes",
      "admin_general_pricing_description": "Estas tarifas se aplican por defecto a todos los clientes",
      "admin_add_pricing_rate": "Añadir Tarifa",
      "admin_edit_pricing_rate": "Editar Tarifa",
      "admin_add_new_pricing_rate": "Añadir Nueva Tarifa",
      "admin_configure_pricing_description": "Configura la tarifa para un rango de distancia",
      "admin_min_distance_km": "Distancia Mínima (km)",
      "admin_max_distance_km": "Distancia Máxima (km)",
      "admin_price_delivery": "Precio Servicio Entrega (€)",
      "admin_price_bc": "Precio Servicio B-C (€)",
      "admin_price_tradein": "Precio Servicio TRADE-IN (€)",
      "admin_price_representation": "Precio Servicio Representación (€)",
      "admin_per_km_section": "Precios por km adicional (opcional - para rangos 1001+ km)",
      "admin_per_km_delivery": "Entrega - Precio por km adicional (€)",
      "admin_per_km_bc": "B-C - Precio por km adicional (€)",
      "admin_per_km_tradein": "TRADE-IN - Precio por km adicional (€)",
      "admin_per_km_note": "Si se define, el precio será: base + (km - 1001) × este valor",
      "admin_placeholder_040": "Ej: 0.40",
      "admin_placeholder_032": "Ej: 0.32",
      "admin_placeholder_028": "Ej: 0.28",
      "admin_pricing_table_title": "Tabla de Tarifas Generales Clientes",
      "admin_pricing_table_description": "Por defecto, todos los clientes usan estas tarifas",
      "admin_pricing_col_distance": "Distancia (km)",
      "admin_pricing_col_delivery": "Entrega (€)",
      "admin_pricing_col_bc": "Servicio B-C (€)",
      "admin_pricing_col_tradein": "TRADE-IN (€)",
      "admin_pricing_col_representation": "Representación (€)",
      "admin_pricing_col_actions": "Acciones",
      "admin_no_rates_configured": "No hay tarifas configuradas. Haz clic en \"Añadir Tarifa\" para crear una.",
      "admin_per_km_suffix": "km adicional",
      "admin_additional_services_title": "Servicios Adicionales",
      "admin_additional_services_description": "Tarifas de servicios extras disponibles para todos los clientes",
      "admin_add_service": "Agregar Servicio",
      "admin_edit_additional_service": "Editar Servicio Adicional",
      "admin_new_additional_service": "Nuevo Servicio Adicional",
      "admin_edit_additional_service_desc": "Modifica los datos del servicio",
      "admin_new_additional_service_desc": "Agrega un nuevo servicio adicional",
      "admin_service_name_label": "Nombre del Servicio",
      "admin_service_name_placeholder": "Ej: Limpieza Exterior",
      "admin_service_price_label": "Precio (€)",
      "admin_billing_unit_label": "Unidad de Cobro",
      "admin_unit_per_service": "Por Servicio",
      "admin_unit_per_hour": "Por Hora",
      "admin_unit_per_vehicle": "Por Vehículo",
      "admin_service_description_label": "Descripción",
      "admin_service_description_placeholder": "Descripción del servicio",
      "admin_additional_services_col_service": "Servicio",
      "admin_additional_services_col_price": "Precio (€)",
      "admin_additional_services_col_unit": "Unidad",
      "admin_additional_services_col_description": "Descripción",
      "admin_additional_services_col_actions": "Acciones",
      "admin_no_additional_services": "No hay servicios adicionales configurados",
      "admin_driver_pricing_title": "Tarifas para Conductores",
      "admin_driver_pricing_subtitle": "Gestiona las tarifas que se pagan a los conductores por sus servicios",
      "admin_new_template": "Nueva Plantilla",
      "admin_view_rates": "Ver Tarifas",
      "admin_badge_high_end": "Alta gama",
      "admin_badge_standard": "Estándar",
      "admin_badge_premium_plus_10": "Premium +10%",
      "admin_how_tariff_system_works": "Cómo funciona el sistema de tarifas",
      "admin_basic_tariff_explanation": "Básica: Tarifa estándar para la mayoría de servicios",
      "admin_premium_tariff_explanation": "Premium: Tarifa superior con mejores márgenes",
      "admin_jluis_tariff_explanation": "JLUIS: Tarifa premium + 10% adicional (calculada automáticamente)",
      "admin_tariff_assignment_explanation": "Al asignar un conductor a un servicio, el admin elige la tarifa que aplica",
      "admin_custom_tariff_explanation": "También se puede ingresar una tarifa personalizada para casos especiales",
      "admin_tariff_comparison_title": "Comparativa de Tarifas (Ejemplo: 500 km)",
      "admin_tariff_comparison_subtitle": "Precios aproximados para servicios de 500 km",
      "admin_standard_delivery": "Entrega estándar",
      "admin_superior_delivery": "Entrega superior",
      "admin_premium_plus_10_label": "Premium + 10%",
      "admin_pricing_disclaimer": "* Los precios exactos varían según la distancia y tipo de servicio",
      "admin_services_with": "Servicios con {{name}}",
      "admin_error_load_rates": "Error al cargar las tarifas",
      "admin_rates_for_template": "Tarifas - {{name}}",
      "admin_all_rates_configured_for_template": "Todas las tarifas configuradas para esta plantilla",
      "admin_range_km": "Rango (km)",
      "admin_rates_col_delivery": "Entrega",
      "admin_rates_col_bc": "B-C",
      "admin_rates_col_tradein": "Trade-In",
      "admin_rates_col_representation": "Representación",
      "admin_rates_col_actions": "Acciones",
      "admin_base_plus_per_km": "Base + adicional por km",
      "admin_no_rates_for_template": "No hay tarifas configuradas para esta plantilla",
      "admin_create_new_pricing_template": "Crear Nueva Plantilla de Tarifas",
      "admin_new_template_intro": "La nueva plantilla se creará con las mismas tarifas que la plantilla Básica. Puedes editarlas después.",
      "admin_template_name_required": "Nombre de la Plantilla *",
      "admin_template_name_placeholder": "Ej: Premium Plus, Especial, etc.",
      "admin_template_description_placeholder": "Breve descripción de esta plantilla",
      "admin_note": "Nota:",
      "admin_new_template_note_body": "La nueva plantilla se creará automáticamente con 17 rangos de tarifas (basadas en la plantilla Básica). Podrás editarlas individualmente después de crearla.",
      "admin_create_template": "Crear Plantilla",
      "admin_creating": "Creando...",
      "admin_assign_rate": "Asignar Tarifa",
      "admin_create_new_template_singular": "Crear Nueva Plantilla de Tarifa",
      "admin_define_template_desc": "Define un nombre y descripción para la nueva plantilla de tarifas",
      "admin_template_placeholder_vip": "Ej: Tarifa VIP Madrid",
      "admin_template_description_optional": "Descripción (opcional)",
      "admin_template_placeholder_special": "Ej: Tarifa especial para clientes VIP en Madrid",
      "admin_no_custom_templates": "No hay plantillas personalizadas.",
      "admin_click_new_template_to_create": "Haz clic en \"Nueva Plantilla\" para crear una.",
      "admin_custom_pricing_clients_title": "Tarifas Personalizadas Clientes",
      "admin_custom_pricing_subtitle": "Gestiona plantillas de tarifas y asígnalas a clientes específicos",
      "admin_clients_and_assigned_rates": "Clientes y sus Tarifas Asignadas",
      "admin_clients_assigned_rates_description": "Todos los clientes registrados y la tarifa que están utilizando",
      "admin_no_clients_registered": "No hay clientes registrados",
      "admin_assigned_rate": "Tarifa Asignada",
      "admin_general_rate": "Tarifa General",
      "admin_custom_rate": "Tarifa Personalizada",
      "admin_change": "Cambiar",
      "admin_email_header": "Email",
      "admin_default_badge": "Predeterminada",
      "admin_standard_rate_default": "Tarifa estándar aplicada por defecto a todos los clientes",
      "admin_clients_count": "{{count}} clientes",
      "admin_available_rate_templates": "Plantillas de Tarifas Disponibles",
      "admin_manage_templates_assign_clients": "Gestiona las plantillas de tarifas que puedes asignar a los clientes",
      "admin_distance_ranges": "Rangos de Distancia",
      "admin_add_rate": "Agregar Tarifa",
      "admin_add_rate_to": "Agregar Tarifa a {{name}}",
      "admin_add_rate_dialog_desc": "Define un rango de distancia y los precios para cada tipo de servicio",
      "admin_price_delivery_eur": "Precio Entrega (€)",
      "admin_price_bc_eur": "Precio B-C (€)",
      "admin_price_tradein_eur": "Precio TRADE-IN (€)",
      "admin_price_representation_eur": "Precio Representación (€)",
      "admin_template_clidrive_name": "Tarifa Clidrive",
      "admin_template_clidrive_description": "Tarifas especiales para Clidrive",
      "admin_client_invoices_subtitle": "Gestiona y genera facturas para los servicios de clientes",
      "admin_generate_invoices": "Generar Facturas",
      "admin_current_period_in_progress": "Período Actual - EN CURSO",
      "admin_services_period": "Servicios: {{start}} - {{end}}",
      "admin_billing_expected": "Facturación prevista: {{start}} - {{end}}",
      "admin_no_services_pending_invoice": "No hay servicios pendientes de facturar",
      "admin_metric_clients": "Clientes",
      "admin_metric_services": "Servicios",
      "admin_taxable_base": "Base Imponible",
      "admin_total_with_vat": "Total con IVA",
      "admin_invoices_col_client": "CLIENTE",
      "admin_invoices_col_services": "SERVICIOS",
      "admin_invoices_col_base": "BASE",
      "admin_invoices_col_iva": "IVA (21%)",
      "admin_invoices_col_total": "TOTAL",
      "admin_invoices_col_actions": "ACCIONES",
      "admin_view_detail": "Ver Detalle",
      "admin_hide": "Ocultar",
      "admin_services_detail": "Detalle de Servicios",
      "admin_invoices_col_date": "FECHA",
      "admin_invoices_col_plate": "MATRÍCULA",
      "admin_invoices_col_vehicle": "VEHÍCULO",
      "admin_invoices_col_type": "TIPO",
      "admin_invoices_col_extras": "EXTRAS",
      "admin_nif_label": "NIF",
      "admin_generate_client_invoices_title": "Generar Facturas de Clientes",
      "admin_generate_client_invoices_desc": "Genera las facturas para el período seleccionado. Solo se incluirán servicios entregados.",
      "admin_fortnight_type": "Tipo de Quincena",
      "admin_quincena_1_option": "Quincena 1 (Serv. 25-9 → Factura 10-15)",
      "admin_quincena_2_option": "Quincena 2 (Serv. 10-24 → Factura 25-último)",
      "admin_year": "Año",
      "admin_month_of_payment": "Mes (del pago)",
      "admin_period_summary": "Resumen del período:",
      "admin_services_period_short": "Servicios: {{range}}",
      "admin_billing_period_short": "Facturación: {{range}}",
      "admin_payment_period_short": "Pago: {{range}}",
      "admin_billing_25_end": "25-último",
      "admin_generating": "Generando...",
      "admin_driver_liquidations_title": "Liquidaciones Conductores",
      "admin_driver_liquidations_subtitle": "Gestiona los pagos y liquidaciones de conductores",
      "admin_generate_liquidations": "Generar Liquidaciones",
      "admin_generate_liquidations_desc": "Genera las liquidaciones para el período seleccionado. Solo se incluirán servicios con gastos aprobados.",
      "admin_generation_stopped": "Generación detenida",
      "admin_generation_stopped_reason": "No se generaron liquidaciones: {{reason}}",
      "admin_payment_periods": "Períodos de Pago",
      "admin_quincena_1_desc": "Quincena 1: Servicios del 25 al 9 → Pago del 10 al 15",
      "admin_quincena_2_desc": "Quincena 2: Servicios del 10 al 24 → Pago del 25 al último día",
      "admin_only_approved_expenses": "Solo se incluyen servicios con gastos aprobados",
      "admin_pending_expense_approval_count": "Hay {{count}} servicio(s) pendientes de aprobación de gastos",
      "admin_pending_expense_reports": "Reportes de Gastos Pendientes ({{count}})",
      "admin_approve_reject_expenses_desc": "Aprueba o rechaza los gastos reportados por conductores",
      "admin_no_pending_reports": "No hay reportes pendientes de aprobación",
      "admin_billing_periods_title": "Períodos de Facturación",
      "admin_billing_periods_subtitle": "Liquidaciones agrupadas por período de pago",
      "admin_search_driver_placeholder": "Buscar conductor...",
      "admin_loading_periods": "Cargando períodos...",
      "admin_in_progress": "EN CURSO",
      "admin_invoice_pending": "FACTURA PENDIENTE",
      "admin_period_closed_ready_to_bill": "Período cerrado, listo para facturar",
      "admin_period_closed_generate_message": "Este período ha cerrado. Genera las liquidaciones para procesar los pagos a conductores.",
      "admin_generate_settlements_first": "Genera primero las liquidaciones para este período",
      "admin_billing_details": "Datos de facturación",
      "admin_save_billing_data": "Guardar Datos",
      "admin_realtime_accumulation": "Acumulación en Tiempo Real",
      "admin_expected_payment": "Pago previsto",
      "admin_services_count_label": "servicios",
      "admin_total_accumulated": "total acumulado",
      "admin_amounts_update_note": "Los montos se actualizan conforme se aprueban gastos. La liquidación se genera al cerrar el período.",
      "admin_liquidated": "LIQUIDADO",
      "admin_driver_col": "CONDUCTOR",
      "admin_supplies_col": "SUPLIDOS",
      "admin_irpf_col": "IRPF",
      "admin_status_col": "ESTADO",
      "admin_no_drivers_match": "No se encontraron conductores con ese nombre",
      "admin_no_approved_pending_liquidation": "No hay servicios aprobados pendientes de liquidar",
      "admin_no_drivers_in_period": "No hay conductores en este período",
      "admin_reported_label": "Reportado",
      "admin_expense_driver": "Conductor",
      "admin_expense_fuel": "Gasolina",
      "admin_expense_toll": "Peajes",
      "admin_expense_parking": "Parking",
      "admin_expense_taxi": "Taxi",
      "admin_expense_other": "Otros",
      "admin_other_expenses_label": "Otros gastos:",
      "admin_tickets_receipts": "Tickets y Recibos ({{count}})",
      "admin_ticket_label": "Ticket",
      "admin_approve_btn": "Aprobar",
      "admin_reject_btn": "Rechazar",
      "admin_reject_reason_prompt": "Razón del rechazo:",
      "admin_hide_services": "Ocultar servicios",
      "admin_view_services": "Ver servicios",
      "admin_payment_label": "Pago",
      "admin_approvals_subtitle": "Revisa y aprueba los servicios completados por conductores",
      "admin_services_pending_approval_title": "Servicios Pendientes de Aprobación",
      "admin_services_pending_approval_desc": "Servicios que han sido completados y esperan aprobación",
      "admin_no_services_pending_approval": "No hay servicios pendientes de aprobación",
      "admin_vehicle_label": "Vehículo",
      "admin_origin_label": "Origen",
      "admin_destination_label": "Destino",
      "admin_total_price_label": "Precio Total",
      "admin_service_status_label": "Estado del Servicio",
      "admin_service_type_label": "Tipo de Servicio",
      "admin_pending_approval_badge": "Pendiente Aprobación",
      "admin_photos_pickup_label": "Fotos Recogida",
      "admin_photos_delivery_label": "Fotos Entrega",
      "admin_expenses_label": "Gastos",
      "admin_view_photos_btn": "Ver Fotos",
      "admin_profiles_title": "Perfiles",
      "admin_profiles_subtitle": "Visualiza y gestiona los perfiles de clientes y conductores",
      "admin_profiles_subtitle_drivers_only": "Visualiza y gestiona los perfiles de tus conductores asignados",
      "admin_profiles_clients_tab": "Perfiles de Clientes",
      "admin_profiles_drivers_tab": "Perfiles de Conductores",
      "admin_clients_registered": "Clientes Registrados",
      "admin_create_client": "Crear Cliente",
      "admin_create_new_client": "Crear Nuevo Cliente",
      "admin_create_new_client_desc": "Crea un nuevo cliente. Se generará una contraseña automáticamente y se enviará por email.",
      "admin_create_client_password_info": "Se generará una contraseña aleatoria y se enviará al email del cliente junto con sus credenciales de acceso.",
      "admin_search_client_placeholder": "Buscar por nombre, DNI/NIF/CIF/NIE o email...",
      "admin_no_clients_search": "No se encontraron clientes con ese criterio de búsqueda",
      "admin_no_clients_registered": "No hay clientes registrados",
      "admin_cif_dni_label": "CIF/DNI:",
      "admin_phone_label": "Teléfono:",
      "admin_address_label": "Dirección:",
      "admin_country_label": "País:",
      "admin_registered_label": "Registrado:",
      "admin_rate_label": "Tarifa:",
      "admin_not_specified": "No especificado",
      "admin_not_specified_f": "No especificada",
      "admin_view_details": "Ver Detalles",
      "admin_search_driver_placeholder": "Buscar por nombre, DNI/NIE, licencia o email...",
      "admin_no_drivers_search": "No se encontraron conductores con ese criterio de búsqueda",
      "admin_no_drivers_registered": "No hay conductores registrados",
      "admin_driver_dni_label": "DNI/NIF:",
      "admin_driver_status_label": "Estado:",
      "admin_available": "Disponible",
      "admin_not_available": "No disponible",
      "admin_edit": "Editar",
      "admin_view_more": "Ver más",
      "admin_driver_badge_validated": "✓ Validado",
      "admin_driver_badge_pending": "⏳ Pendiente",
      "admin_driver_badge_expires_soon": "⚠️ Vence Pronto",
      "admin_driver_badge_no_docs": "❌ Sin Documentos",
      "admin_edit_client": "Editar Cliente",
      "admin_edit_client_desc": "Modifica la información del cliente. El admin puede editar todo, incluyendo el email.",
      "admin_company_logo": "Logo de la Empresa",
      "admin_upload_logo": "Subir Logo",
      "admin_uploading": "Subiendo...",
      "admin_logo_hint": "PNG, JPG • Max 2MB",
      "admin_name_required": "Nombre *",
      "admin_email_required": "Email *",
      "admin_email_change_warning": "Cambiar el email afectará el acceso del cliente",
      "admin_company_name": "Nombre de Empresa",
      "admin_cif_dni": "CIF/DNI",
      "admin_phone": "Teléfono",
      "admin_country": "País",
      "admin_address": "Dirección",
      "admin_country_placeholder": "ES, FR, etc.",
      "admin_payment_type": "Tipo de Pago",
      "admin_payment_biweekly": "Quincenal (Transferencia)",
      "admin_payment_instant": "Pago Instantáneo (TPV Virtual)",
      "admin_payment_biweekly_desc": "Se factura cada 15 días y se paga por transferencia bancaria",
      "admin_payment_instant_desc": "Se cobra al momento al crear o editar servicios vía TPV Virtual Santander",
      "admin_save_changes": "Guardar Cambios",
      "admin_documents_drivers_title": "Documentos Conductores",
      "admin_documents_subtitle": "Revisa y valida los documentos subidos por conductores",
      "admin_documents_pending_expired_title": "Documentos Pendientes y Vencidos",
      "admin_documents_require_attention": "Total: {{count}} documentos requieren atención",
      "admin_no_documents_pending": "No hay documentos pendientes de validación",
      "admin_document_label": "Documento:",
      "admin_upload_date_label": "Fecha de subida:",
      "admin_expiry_date_label": "Fecha de vencimiento:",
      "admin_status_label": "Estado:",
      "admin_status_expired": "⚠️ Vencido",
      "driver_name_label": "Nombre",
      "driver_phone_label": "Teléfono",
      "driver_not_specified": "No especificado",
      "driver_type_label": "Tipo",
      "driver_fleet_member": "Miembro de Flota",
      "driver_independent": "Conductor Independiente",
      "driver_doc_status": "Estado de Documentos",
      "driver_docs_loading": "Cargando documentos...",
      "driver_documents": "Documentos",
      "driver_view": "Ver",
      "driver_download": "Descargar",
      "driver_preview_title": "Vista Previa",
      "driver_view_doc_tooltip": "Ver documento en nueva pestaña",
      "driver_download_doc_tooltip": "Descargar documento",
      "driver_delete_doc_tooltip": "Eliminar documento",
      "driver_expires": "Vence:",
      "driver_bank_account": "Cuenta Bancaria",
      "driver_tax_id": "NIF/CIF",

      // Messages
      "order_created": "¡Servicio creado exitosamente!",
      "order_updated": "¡Servicio actualizado exitosamente!",
      "payment_success": "¡Pago completado exitosamente!",
      "payment_failed": "Pago fallido. Por favor intenta nuevamente.",
      "error_occurred": "Ocurrió un error. Por favor intenta nuevamente.",
      "auth_callback_no_session_id": "No se encontró ID de sesión",
      "address_toast_selected": "✓ Dirección seleccionada correctamente",
      "address_toast_no_coords": "No se pudieron obtener las coordenadas de esta dirección",
      "address_toast_init_error": "Error al inicializar autocompletado. Usa los botones de ciudad.",
      "address_toast_city_selected": "✓ Ciudad seleccionada: {{city}}",
      "address_toast_coords_set": "✓ Coordenadas establecidas correctamente",
      "address_toast_invalid_coords": "Coordenadas inválidas. Lat: -90 a 90, Lng: -180 a 180",
      "address_toast_coords_extracted": "✓ Coordenadas extraídas del enlace de Google Maps",
      "address_toast_coords_extract_error": "No se pudieron extraer coordenadas del enlace",
      "address_toast_select_suggestions": "Por favor selecciona una dirección de las sugerencias",
      "address_toast_error_get_details": "Error al obtener detalles de la dirección",
      "forgot_toast_success": "Se ha enviado un enlace de recuperación a tu correo",
      "forgot_toast_error": "Error al procesar tu solicitud",
      "forgot_toast_error_send": "Error al enviar el correo",
      "forgot_toast_email_not_sent": "Si tu correo está registrado, no pudimos enviar el email. Contacta con soporte.",
      "forgot_network_error": "Error de red",
      "forgot_title": "Recuperar Contraseña",
      "forgot_description": "Ingresa tu correo electrónico y te enviaremos instrucciones",
      "forgot_email_label": "Correo Electrónico",
      "forgot_email_placeholder": "tu@email.com",
      "forgot_sending": "Enviando...",
      "forgot_submit": "Enviar Enlace de Recuperación",
      "forgot_back_login": "Volver al inicio de sesión",
      "change_password_mismatch": "Las contraseñas no coinciden",
      "change_password_min_length": "La contraseña debe tener al menos 6 caracteres",
      "change_password_success": "Contraseña actualizada correctamente",
      "change_password_error": "Error al cambiar la contraseña",
      "change_password_description": "Por favor, establece una nueva contraseña segura",
      "change_password_btn": "Actualizar Contraseña",
      "change_password_updating": "Actualizando...",
      "admin_login_toast_success": "¡Acceso correcto!",
      "admin_login_toast_error": "Email o contraseña incorrectos",
      "admin_back_to_home": "Volver al inicio",
      "admin_sign_in": "Iniciar sesión",
      "admin_signing_in": "Iniciando sesión...",
      "client_login_welcome": "¡Bienvenido!",
      "client_login_error": "Error al iniciar sesión",
      "client_toast_no_session": "No hay sesión activa. Por favor, inicia sesión nuevamente.",
      "client_toast_preparing_contract": "Preparando contrato...",
      "client_toast_contract_generated": "Contrato generado. Si no se descarga automáticamente, verifica el bloqueador de ventanas emergentes.",
      "client_toast_error_download_contract": "Error al descargar el contrato",
      "client_toast_error_load_invoices": "Error al cargar facturas",
      "client_toast_photos_pending_approval": "Las fotos están pendientes de aprobación del administrador",
      "client_toast_photos_not_available": "Las fotos aún no están disponibles",
      "client_toast_no_photos_yet": "No hay fotos disponibles todavía",
      "client_toast_error_load_photos": "Error al cargar las fotos",
      "client_toast_no_expenses_yet": "No hay gastos aprobados todavía",
      "client_toast_error_load_expenses": "Error al cargar los gastos",
      "client_toast_error_load_completion": "Error al cargar los detalles de finalización",
      "client_toast_distance_calculated": "Distancia calculada: {{distance}} km - Precio: €{{price}}",
      "client_toast_error_calculate_distance": "Error al calcular la distancia",
      "client_toast_service_cancelled_fee": "Servicio cancelado: {{status}}. Cargo: €{{fee}}",
      "client_toast_error_cancel_service": "Error al cancelar el servicio",
      "client_toast_price_updated": "Precio actualizado",
      "client_toast_error_calculate_price": "Error al calcular el precio",
      "client_toast_enter_valid_distance": "Introduce una distancia válida",
      "client_completion_waiting_extras": "Tiempo de espera / Extras",
      "client_completion_extras_total": "Total extras (sin IVA)",
      "service_toast_load_failed": "No se pudo cargar el servicio",
      "service_toast_error_load": "Error al cargar el servicio",
      "service_toast_updated": "Servicio actualizado correctamente",
      "service_toast_error_update": "Error al actualizar",
      "service_toast_error_update_service": "Error al actualizar el servicio",
      "service_toast_error_upload_file": "Error al subir {{fileName}}",
      "service_toast_photos_uploaded": "{{count}} foto(s) subida(s)",
      "service_toast_error_upload_photos": "Error al subir las fotos",
      "service_toast_completed": "Servicio completado correctamente",
      "service_toast_error_complete": "Error al completar",
      "service_toast_error_complete_service": "Error al completar el servicio",
      "service_toast_reverted": "Servicio revertido correctamente",
      "service_toast_error_revert": "Error al revertir",
      "service_toast_error_revert_service": "Error al revertir el servicio",
      "service_toast_deleted": "Servicio eliminado",
      "service_toast_error_delete": "Error al eliminar",
      "service_toast_error_delete_service": "Error al eliminar el servicio",
      "service_toast_cancelled": "Servicio cancelado",
      "service_toast_error_cancel": "Error al cancelar",
      "service_toast_error_cancel_service": "Error al cancelar el servicio",
      "service_toast_contract_downloaded": "Contrato descargado",
      "service_toast_error_generate_contract": "Error al generar el contrato",
      "service_toast_error_download_contract": "Error al descargar el contrato",
      "service_toast_opening_calendar": "Abriendo Google Calendar...",
      "driver_toast_contract_downloaded": "Contrato descargado correctamente",
      "driver_toast_error_download_contract": "Error al descargar el contrato",
      "driver_toast_error_load_drivers": "Error al cargar choferes",
      "driver_toast_driver_created": "Chofer creado. Documentos pendientes de aprobación por admin.",
      "driver_toast_driver_created_with_password": "Chofer creado correctamente. ⚠️ Contraseña temporal: {{temp_password}}. Por favor, comunícasela al conductor.",
      "driver_toast_error_create_driver": "Error al crear chofer: {{message}}",
      "driver_error_create_driver_fallback": "Error al crear chofer",
      "driver_toast_driver_updated": "Chofer actualizado correctamente",
      "driver_toast_error_update_driver": "Error al actualizar chofer",
      "driver_toast_driver_deleted": "Chofer eliminado correctamente",
      "driver_toast_error_delete_driver": "Error al eliminar chofer",
      "driver_toast_service_assigned_self": "Servicio asignado a ti mismo.",
      "driver_toast_service_reassigned": "Servicio reasignado correctamente. Email enviado.",
      "driver_toast_service_assigned": "Servicio asignado correctamente. Email enviado.",
      "driver_toast_error_assign_service": "Error al asignar servicio",
      "driver_toast_logged_out": "Sesión cerrada",
      "driver_toast_error_load_billing_periods": "Error al cargar periodos de facturación",
      "driver_toast_error_load_period_details": "Error al cargar detalles del período",
      "driver_toast_error_load_incomplete_services": "Error al cargar servicios incompletos",
      "driver_toast_complete_required_fields": "Por favor completa todos los campos obligatorios",
      "driver_toast_profile_updated": "Perfil actualizado exitosamente",
      "driver_toast_new_iban_next_invoice": "El nuevo número de cuenta se utilizará en tu próxima factura",
      "driver_toast_error_update_profile": "Error al actualizar perfil",
      "driver_toast_error_save_changes": "Error al guardar cambios",
      "driver_toast_member_updated": "Miembro actualizado correctamente.",
      "driver_toast_member_updated_with_docs": "Miembro actualizado correctamente. {{count}} documento(s) subido(s).",
      "driver_toast_error_update_member": "Error al actualizar miembro",
      "driver_toast_select_file": "Por favor selecciona un archivo",
      "driver_toast_document_uploaded": "Documento subido correctamente",
      "driver_toast_error_upload_document": "Error al subir documento",
      "driver_toast_select_at_least_one_photo": "Selecciona al menos una foto",
      "driver_toast_pickup_photos_uploaded": "Fotos de recogida subidas correctamente",
      "driver_toast_error_upload_photos": "Error al subir fotos",
      "driver_toast_error_upload_pickup_photos": "Error al subir fotos de recogida",
      "driver_toast_delivery_photos_uploaded": "Fotos de entrega subidas correctamente",
      "driver_toast_error_upload_delivery_photos": "Error al subir fotos de entrega",
      "driver_toast_select_contract_photo": "Selecciona al menos una foto del contrato",
      "driver_toast_contract_uploaded": "Contrato subido correctamente",
      "driver_toast_error_upload_contract": "Error al subir contrato",
      "driver_toast_expense_report_sent": "Reporte de gastos enviado correctamente",
      "driver_toast_error_send_report": "Error al enviar reporte",
      "driver_toast_error_connection_expense_report": "Error de conexión al enviar reporte de gastos",
      "driver_toast_service_completed": "Servicio completado exitosamente",
      "admin_toast_error_load_photos": "Error al cargar las fotos",
      "admin_toast_error_load_expenses": "Error al cargar los gastos",
      "admin_toast_failed_load_data": "Error al cargar los datos",
      "admin_toast_error_load_billing": "Error al cargar datos de facturación",
      "admin_toast_partial_load": "Parte de los datos no se pudieron cargar. Actualiza la página para intentar de nuevo.",
      "admin_toast_error_generate_liquidations": "Error al generar liquidaciones",
      "admin_toast_error_generate_client_invoices": "Error al generar facturas de cliente",
      "admin_toast_excel_downloaded": "Excel descargado",
      "admin_toast_error_download_excel": "Error al descargar Excel",
      "admin_toast_error_load_period_details": "Error al cargar detalles del periodo",
      "admin_toast_error_load_period_trips": "Error al cargar viajes del periodo",
      "admin_toast_driver_profile_incomplete": "El perfil del conductor está incompleto. Por favor, edita el conductor y completa todos los campos de facturación (nombre completo, DNI/NIE, dirección fiscal, banco y cuenta bancaria).",
      "admin_toast_error_generate_invoice": "Error al generar factura. Por favor, verifica que el conductor tenga todos los datos de facturación completos.",
      "admin_toast_select_charge_and_amount": "Selecciona un tipo de cargo e ingresa el importe",
      "admin_toast_error_update_report": "Error al actualizar reporte",
      "admin_toast_period_marked_paid": "Período marcado como pagado",
      "admin_toast_error_mark_period_paid": "Error al marcar período como pagado",
      "admin_toast_failed_save_driver": "Error al guardar el conductor",
      "admin_toast_driver_deleted": "Conductor eliminado correctamente",
      "admin_toast_failed_delete_driver": "Error al eliminar el conductor",
      "admin_toast_error_save_rate": "Error al guardar la tarifa",
      "admin_toast_pricing_deleted": "Tarifa eliminada correctamente",
      "admin_toast_failed_delete_pricing": "Error al eliminar la tarifa",
      "admin_toast_error_save_service": "Error al guardar el servicio",
      "admin_toast_service_deleted": "Servicio eliminado correctamente",
      "admin_toast_error_delete_service": "Error al eliminar el servicio",
      "admin_toast_template_created": "Plantilla de tarifa creada correctamente",
      "admin_toast_error_create_template": "Error al crear la plantilla",
      "admin_toast_template_deleted": "Plantilla eliminada correctamente",
      "admin_toast_error_delete_template": "Error al eliminar la plantilla",
      "admin_toast_rate_added": "Tarifa agregada correctamente",
      "admin_toast_rate_deleted": "Tarifa eliminada correctamente",
      "admin_toast_error_delete_rate": "Error al eliminar la tarifa",
      "admin_toast_rate_assigned": "Tarifa asignada correctamente al cliente",
      "admin_toast_error_assign_rate": "Error al asignar la tarifa",
      "admin_toast_custom_rate_removed": "Tarifa personalizada removida. Cliente usa tarifas generales.",
      "admin_toast_error_remove_assignment": "Error al remover la asignación",
      "admin_toast_client_updated": "Cliente actualizado correctamente",
      "admin_toast_error_update_client": "Error al actualizar cliente",
      "admin_toast_driver_updated": "Conductor actualizado correctamente",
      "admin_toast_error_open_document": "Error al abrir el documento",
      "admin_toast_error_view_document": "Error al visualizar el documento",
      "admin_toast_file_too_large": "El archivo es demasiado grande. Máximo 5MB.",
      "admin_toast_invalid_format": "Formato no válido. Solo se permiten JPG, PNG o PDF.",
      "admin_toast_license_expiry_required": "Por favor, introduce la fecha de vencimiento de la licencia",
      "admin_toast_dni_expiry_required": "Por favor, introduce la fecha de vencimiento del DNI",
      "admin_toast_client_created": "Cliente creado correctamente. Email de bienvenida enviado.",
      "admin_toast_client_created_no_email": "Cliente creado correctamente. No se pudo enviar el email; comparte las credenciales manualmente.",
      "admin_toast_error_upload_photos": "Error al subir las fotos",
      "admin_toast_service_completed_historic": "Servicio completado y pasado al histórico",
      "admin_toast_error_connection_complete": "Error de conexión al completar el servicio",
      "admin_toast_error_revert_service": "Error al revertir el servicio",
      "admin_toast_error_load_service_details": "Error al cargar los detalles del servicio",
      "admin_toast_complete_pickup_delivery": "Por favor completa las direcciones de recogida y entrega",
      "admin_toast_complete_vehicle_data": "Por favor completa los datos del vehículo",
      "admin_toast_set_driver_price": "Por favor establece el precio para el conductor",
      "admin_toast_logo_uploaded": "Logo subido correctamente",
      "admin_toast_document_approved": "Documento aprobado",
      "admin_toast_error_approve_document": "Error al aprobar documento",
      "admin_toast_document_rejected": "Documento rechazado. Email enviado al conductor.",
      "admin_toast_document_rejected_no_email": "Documento rechazado. No se pudo enviar el email al conductor.",
      "admin_toast_driver_created_no_email": "Conductor creado correctamente. No se pudo enviar el email de bienvenida; comparte las credenciales manualmente.",
      "admin_toast_error_reject_document": "Error al rechazar documento",
      "admin_toast_select_rate_before_save": "Debes seleccionar una tarifa para el conductor (Básica, Premium, JLUIS o Personalizada) antes de guardar",
      "admin_toast_complete_all_fields": "Por favor completa todos los campos",
      "admin_toast_invoice_uploaded": "Factura subida correctamente",
      "admin_toast_period_marked_paid_short": "Periodo marcado como pagado",
      "admin_toast_error_mark_period_paid": "Error al marcar el periodo como pagado",
      "admin_toast_invoice_deleted": "Factura eliminada correctamente",
      "admin_toast_error_delete_invoice": "Error al eliminar la factura",
      "admin_toast_period_no_services": "El periodo no tiene servicios asociados",
      "admin_toast_warning_period_no_services": "Este periodo no tiene servicios",
      "admin_toast_warning_services_not_found": "No se encontraron los servicios de este periodo en la base de datos",
      "admin_toast_service_not_found": "Servicio no encontrado",
      "admin_toast_service_no_distance": "El servicio no tiene distancia definida",
      "admin_toast_service_no_type": "El servicio no tiene tipo definido",
      "admin_toast_error_calculate_prices": "Error al calcular precios",
      "admin_toast_driver_docs_not_validated": "Este conductor no tiene los documentos validados. No se puede asignar servicios.",
      "admin_toast_enter_distance_before_assign": "Por favor ingresa la distancia del servicio antes de asignar un conductor.",
      "admin_toast_select_service_type_before_assign": "Por favor selecciona el tipo de servicio antes de asignar un conductor.",
      "admin_toast_templates_not_loaded": "Error: No se han cargado las plantillas de tarifas. Por favor recarga la página.",
      "admin_toast_could_not_calculate_rates": "No se pudieron calcular las tarifas.",
      "admin_toast_error_calculate_rates": "Error al calcular tarifas",
      "admin_toast_error_calculate_price_message": "Error al calcular precio: {{message}}",
      "admin_toast_enter_distance_before_rate": "Por favor ingresa la distancia antes de seleccionar tarifa",
      "admin_toast_select_type_before_rate": "Por favor selecciona el tipo de servicio antes de seleccionar tarifa",
      "admin_toast_could_not_calculate_price": "No se pudo calcular el precio. Verifica la distancia y tipo de servicio.",
      "admin_toast_error_calculate_rate_message": "Error al calcular la tarifa: {{message}}",
      "admin_toast_rate_updated": "Tarifa actualizada correctamente",
      "admin_toast_error_update_rate": "Error al actualizar la tarifa",
      "admin_toast_template_name_required": "El nombre de la plantilla es requerido",
      "admin_toast_template_created_short": "Plantilla creada correctamente",
      "admin_toast_contract_downloaded_2pages": "Contrato descargado - 2 páginas: Conductor y Cliente",
      "admin_confirm_delete_driver": "¿Estás seguro de que quieres eliminar este conductor?",
      "admin_confirm_delete_pricing": "¿Estás seguro de que quieres eliminar esta tarifa?",
      "admin_confirm_delete_additional_service": "¿Estás seguro de eliminar este servicio adicional?",
      "admin_confirm_delete_template": "¿Eliminar esta plantilla y todas sus tarifas?",
      "admin_confirm_delete_rate": "¿Eliminar esta tarifa?",
      "admin_confirm_remove_custom_rate": "¿Remover la tarifa personalizada de este cliente?",
      "admin_confirm_delete_service": "¿Estás seguro de que quieres eliminar este servicio? Esta acción no se puede deshacer.",
      "admin_confirm_revert_service": "¿Estás seguro de que quieres devolver este servicio a \"En Proceso\"? Los datos de completación (fotos, gastos) se mantendrán guardados.",
      "admin_confirm_delete_invoice": "¿Eliminar esta factura? El periodo volverá a estado pendiente.",
      "admin_confirm_cancel_order": "¿Estás seguro de que deseas cancelar este servicio?\n\nServicio: #{{serviceId}}\nCliente: {{clientName}}\nConductor: {{driverName}}\n\nSe aplicará la lógica de cancelación automáticamente:\n- Cliente: Cargo según tiempo hasta recogida\n- Conductor: Compensación según tiempo hasta recogida\n- Se enviarán emails de notificación",
      "admin_confirm_cancel_at_pickup": "⚠️ CANCELADO EN SALIDA\n\n¿El vehículo NO está disponible al momento de recogida?\n\nServicio: #{{serviceId}}\nCliente: {{clientName}}\nConductor: {{driverName}}\n\nIMPORTANTE:\n- Cliente: Cargo COMPLETO (100%)\n- Conductor: Pago COMPLETO (100%)\n- Pasa a HISTÓRICO automáticamente\n- Se enviarán emails de notificación",
      "admin_confirm_cancel_in_transit": "⚠️ CANCELADO EN TRANSPORTE\n\n¿El servicio se canceló durante el trayecto?\n\nServicio: #{{serviceId}}\nCliente: {{clientName}}\nConductor: {{driverName}}\n\nPROCESO:\n1. Servicio pasa a estado PENDIENTE\n2. Conductor debe subir: Gastos, Fotos de recogida, Fotos de donde dejó el vehículo\n3. Tú deberás APROBAR la documentación\n4. Una vez aprobado: Cliente paga 100%, Conductor cobra 100%, Pasa a HISTÓRICO",
      "admin_confirm_approve_transit": "✅ APROBAR CANCELACIÓN EN TRANSPORTE\n\n¿Has revisado la documentación del conductor?\n\nServicio: #{{serviceId}}\nConductor: {{driverName}}\n\nAl aprobar: Cliente pagará 100%, Conductor cobrará 100%, Servicio pasará a HISTÓRICO, Se incluirá en facturación",
      "service_confirm_revert": "¿Estás seguro de que quieres revertir este servicio?",
      "service_confirm_delete": "¿Estás seguro de que quieres ELIMINAR este servicio? Esta acción no se puede deshacer.",
      "driver_confirm_delete_member": "¿Eliminar al chofer {{name}}?",
      "driver_doc_confirm_delete": "¿Estás seguro de que quieres eliminar este documento?",
      "driver_doc_alert_connection_error": "Error de conexión al intentar abrir el documento",
      "driver_doc_alert_download_error": "Error al descargar el documento",
      "driver_doc_alert_deleted": "Documento eliminado correctamente",
      "driver_doc_alert_error_delete": "Error al eliminar el documento",
      "driver_doc_alert_uploaded": "Documento subido correctamente",
      "driver_doc_alert_error_upload": "Error al subir el documento",
      "driver_doc_alert_error_upload_detail": "Error al subir el documento: {{detail}}",
      "service_status_undefined": "No definida",
      "service_status_not_calculated": "No calculada",
      "service_status_pending": "Pendiente",
      "service_status_assigned": "Asignado",
      "service_status_in_progress": "En Progreso",
      "service_status_in_transit": "En Tránsito",
      "service_status_delivered": "Entregado",
      "service_status_cancelled": "Cancelado",
      "service_no_client": "Sin cliente",
      "service_no_driver": "Sin asignar",
      "service_no_plate": "Sin matrícula",
      "driver_no_orders": "No tienes servicios asignados aún",
      "driver_no_orders_filter": "No se encontraron servicios con los filtros aplicados",
      "driver_date_unspecified": "No especificada",
      "driver_pending_approval": "Pendiente de Aprobación",
      "driver_complete_service": "Completar Servicio",
      "driver_not_specified": "No especificado",
      "driver_available": "Disponible",
      "driver_not_available": "No Disponible",
      "driver_saving": "Guardando...",
      "driver_edit_click_hint": "Haz click en \"Editar\" para actualizar tu información.",
      "driver_status_rejected": "Rechazado",
      "driver_send_expense_report": "Enviar Reporte de Gastos",
      "driver_sending": "Enviando...",
      "address_toast_selected": "Dirección seleccionada correctamente",
      "common_document_preview": "Vista previa del documento",
      "ph_description": "Descripción",
      "ph_observations_delivery": "Observaciones sobre la entrega...",
      "ph_email_example": "admin@example.com",
      "ph_enter_password": "Introduce tu contraseña",
      "ph_email_driver": "tu@email.com",
      "ph_password_dots": "••••••••",
      "ph_new_password_placeholder": "Ingresa tu nueva contraseña",
      "ph_city_search": "Escribe una ciudad...",
      "ph_vehicle_address": "Dirección donde se encuentra el vehículo",
      "ph_phone_es": "+34 600 123 456",
      "ph_distance_example": "Ej: 150.5",
      "title_download": "Descargar",
      "title_pdf_viewer": "Visor PDF",
      "ph_company_example": "Ej: AutoTransportes S.L.",
      "ph_select_country": "Seleccionar país",
      "ph_name_example": "Ej: Juan García",
      "ph_lat_example": "Latitud (ej: 41.3851 para Barcelona)",
      "ph_lon_example": "Longitud (ej: 2.1734 para Barcelona)",
      "ph_cities_search": "Madrid, Barcelona...",
      "ph_brands": "Toyota, BMW...",
      "ph_models": "Corolla, Serie 3...",
      "ph_plate_example": "1234ABC",
      "ph_fullname_example": "Ej: Carlos Miguel Fernández García",
      "ph_dni_example": "12345678A",
      "ph_number_short": "15",
      "ph_fiscal_address": "Calle, número, código postal, ciudad, provincia",
      "ph_city_example": "Ej: Santander",
      "ph_iban_example": "ES00 0000 0000 0000 0000 0000",
      "ph_describe_expense": "Describe el gasto",
      "ph_select_client": "Seleccionar cliente",
      "ph_select_client_alt": "Selecciona un cliente",
      "ph_notes_service": "Añade notas o comentarios sobre este servicio...",
      "ph_amount": "0.00",
      "ph_optional": "Opcional",
      "ph_no_client_admin": "Sin cliente (Admin)",
      "ph_search_pickup": "Buscar dirección de recogida...",
      "ph_search_delivery": "Buscar dirección de entrega...",
      "ph_name": "Nombre",
      "ph_invoice_ref": "Ej: 2025/001",
      "ph_no_driver_pending": "Sin asignar (pendiente)",
      "ph_special_instructions": "Instrucciones especiales, observaciones...",
      "ph_toll_example": "Ej: Peaje urbano, etc.",
      "ph_time_example": "Ej: 30 minutos",
      "ph_notes_delivery_optional": "Añade notas sobre la entrega (opcional)...",
      "title_edit_service": "Editar servicio",
      "title_mark_paid": "Marcar como pagado",
      "title_approve_driver": "Aprobar conductor",
      "title_view_profile": "Ver perfil completo",
      "title_view_details": "Ver detalles",
      "title_download_excel": "Descargar Excel",
      "title_download_pdf": "Descargar PDF",
      "title_generate_invoice_pdf": "Generar Factura PDF",
      "ph_address_maps": "💡 Escribe la dirección, selecciona sugerencias o pega un enlace de Google Maps",
      "ph_phone_admin": "+34 600 000 000",
      "ph_qty": "Cant.",
      "ph_price": "Precio",
      "ph_extra_description": "Descripción del extra personalizado...",
      "ph_search_vehicle": "Marca, modelo, matrícula...",
      "ph_price_eur": "Precio en €",
      "ph_brand_toyota": "Toyota",
      "ph_model_corolla": "Corolla",
      "ph_plate_short": "1234ABC",
      "ph_color_example": "Ej: Blanco",
      "ph_year_example": "2023",
      "ph_zero": "0",
      "ph_rate_040": "0.40",
      "ph_rate_032": "0.32",
      "ph_rate_028": "0.28",
      "aria_select_language": "Seleccionar idioma",
      "aria_pagination": "paginación",
      "aria_prev_page": "Ir a la página anterior",
      "aria_next_page": "Ir a la página siguiente",
      "aria_breadcrumb": "miga de pan",
      "common_previous": "Anterior",
      "common_next": "Siguiente",
      "common_close": "Cerrar",
      "period_trips_title": "Detalles de Viajes",
      "period_trips_total_trips": "Total Viajes",
      "period_trips_income": "Ingresos",
      "period_trips_expenses": "Gastos",
      "period_trips_total_vat": "Total con IVA",
      "period_trips_loading": "Cargando viajes...",
      "period_trips_empty": "No hay viajes en este periodo.",
      "period_trips_expenses_approved": "✓ Gastos Aprobados",
      "period_trips_vehicle": "Vehículo:",
      "period_trips_plate": "Matrícula:",
      "period_trips_client": "Cliente:",
      "period_trips_pickup_date": "Fecha Recogida:",
      "period_trips_delivery_date": "Fecha Entrega:",
      "period_trips_service": "Servicio:",
      "period_trips_route": "Ruta:",
      "period_trips_driver_rate": "Tarifa Conductor",
      "period_trips_supplied_expenses": "Gastos Suplidos",
      "period_trips_total_service": "Total Servicio",
      "period_trips_fuel": "Combustible:",
      "period_trips_tolls": "Peajes:",
      "period_trips_parking": "Parking:",
      "period_trips_taxi": "Taxi:",
      "period_trips_other": "Otros:",
      "period_status_completed": "Completado",
      "period_label_period": "Período:",
      "driver_nav_home": "Inicio",
      "driver_nav_services": "Servicios",
      "driver_nav_complete": "Completar",
      "driver_nav_profile": "Mi Perfil",
      "driver_nav_billing": "Facturación",
      "driver_nav_fleet": "Mi Flota",
      "driver_docs_pending_title": "Documentación Pendiente",
      "driver_docs_pending_text": "Debes subir y validar todos los documentos requeridos para poder recibir asignaciones de servicios.",
      "driver_loading": "Cargando...",
      "calendar_scheduled_subtitle": "Tus servicios programados",
      "driver_active_services": "Servicios activos",
      "driver_from_n_services": "De {{count}} servicios",
      "driver_validation_progress": "Progreso de validación ({{uploaded}}/7 subidos)",
      "driver_this_week_n_services": "Esta semana ({{count}} servicios)",
      "driver_status_services": "Estado de Servicios",
      "driver_status_documents": "Estado de Documentos",
      "driver_trend_title": "Tendencia de Servicios e Ingresos",
      "driver_trend_subtitle": "Últimos 6 meses",
      "driver_recent_services": "Servicios Recientes",
      "driver_last_5_assigned": "Últimos 5 servicios asignados",
      "calendar_day": "Día",
      "calendar_week": "Semana",
      "calendar_month": "Mes",
      "calendar_legend_assigned": "Asignado",
      "calendar_legend_completed": "Completado",
      "calendar_legend_today": "Hoy",
      "driver_completed_count": "{{count}} completados",
      "driver_chart_completed": "Servicios Completados",
      "driver_chart_income": "Ingresos",
      "driver_chart_approved": "Aprobados",
      "driver_chart_rejected": "Rechazados",
      "driver_chart_missing": "Faltantes",
      "driver_chart_cancelled": "Cancelados",
      "driver_date_unavailable": "Fecha no disponible",
      "calendar_origin": "Origen:",
      "calendar_destination": "Destino:",
      "calendar_view_full_details": "Ver detalles completos",
      "calendar_no_services": "Sin servicios",
      "calendar_no_services_this_day": "No hay servicios programados para este día",
      "driver_validated": "Validados",
      "driver_commission": "Comisión",
      "driver_services_title": "Servicios",
      "driver_services_subtitle": "Gestiona tus trayectos activos e históricos",
      "driver_services_in_progress": "En proceso",
      "driver_services_historical": "Histórico",
      "driver_filters_title": "Filtros de Búsqueda",
      "driver_clear": "Limpiar",
      "driver_clear_filters": "Limpiar filtros",
      "driver_search_address": "Buscar Dirección/Ciudad",
      "driver_status": "Estado",
      "driver_all": "Todos",
      "driver_driver_label": "Chofer",
      "driver_myself": "Yo mismo",
      "driver_vehicle_brand": "Marca Vehículo",
      "driver_vehicle_model": "Modelo Vehículo",
      "driver_plate": "Matrícula",
      "driver_fuel_type": "Tipo Combustible",
      "driver_fuel_gasoline": "Gasolina",
      "driver_fuel_diesel": "Diesel",
      "driver_fuel_electric": "Eléctrico",
      "driver_fuel_hybrid": "Híbrido",
      "driver_payment_status": "Estado de Pago",
      "driver_paid": "Pagado",
      "driver_unpaid": "No Pagado",
      "driver_showing_services": "Mostrando {{shown}} de {{total}} servicios",
      "driver_table_date": "Fecha",
      "driver_table_trip": "Trayecto",
      "driver_table_vehicle": "Vehículo",
      "driver_table_price": "Precio",
      "driver_table_status": "Estado",
      "driver_table_actions": "Acciones",
      "driver_details": "Detalles",
      "driver_overdue_banner": "Fecha de entrega pasada - Completar servicio urgentemente",
      "driver_origin_short": "Origen",
      "driver_destination_short": "Destino",
      "driver_service_type_delivery": "Entrega",
      "driver_label_remuneration": "Remuneración",
      "driver_label_distance": "Distancia",
      "driver_label_vehicle": "Vehículo",
      "driver_pickup": "RECOGIDA",
      "driver_delivery": "ENTREGA",
      "driver_incomplete_title": "Servicios sin Completar",
      "driver_incomplete_subtitle": "Estos servicios están entregados pero necesitan fotos del vehículo y reporte de gastos antes del cierre del período",
      "driver_loading_services": "Cargando servicios...",
      "driver_all_services_completed": "¡Todos los servicios están completados!",
      "driver_no_pending_complete": "No hay servicios pendientes de completar",
      "driver_rejected": "Rechazado",
      "driver_service_id": "ID del Servicio",
      "driver_date_pickup": "Fecha Recogida",
      "driver_date_delivery_label": "Fecha Entrega",
      "driver_pending_approval_message": "Este servicio está pendiente de aprobación por el administrador. Una vez aprobado, se agregará automáticamente a tu facturación.",
      "driver_rejection_reason": "Motivo de rechazo:",
      "driver_reupload_photos_expenses": "Por favor, vuelve a subir las fotos y/o gastos correctamente.",
      "driver_missing_pickup_photos": "Faltan fotos de recogida",
      "driver_pickup_photos_uploaded": "Fotos de recogida subidas",
      "driver_missing_delivery_photos": "Faltan fotos de entrega",
      "driver_delivery_photos_uploaded": "Fotos de entrega subidas",
      "driver_missing_expense_report": "Falta reporte de gastos",
      "driver_expense_reported": "Gastos reportados",
      "driver_profile_title": "Mi Perfil",
      "driver_profile_subtitle": "Información personal del conductor",
      "driver_label_name": "Nombre",
      "driver_label_phone": "Teléfono",
      "driver_label_dni": "DNI/NIF",
      "driver_label_status": "Estado",
      "driver_status_available": "Disponible",
      "driver_status_not_available": "No Disponible",
      "driver_doc_validation": "Validación de Documentos",
      "driver_validation_pending": "Validación Pendiente",
      "driver_billing_title": "Información de Facturación",
      "driver_billing_description": "Esta información se utiliza para generar tus facturas",
      "driver_billing_full_name": "Nombre Completo Legal",
      "driver_billing_dni": "DNI/NIE",
      "driver_billing_irpf": "Retención IRPF (%)",
      "driver_billing_fiscal_address": "Dirección Fiscal Completa",
      "driver_billing_bank": "Banco",
      "driver_billing_iban": "Número de Cuenta (IBAN)",
      "driver_billing_iban_note": "El cambio de cuenta se aplicará en tu próxima factura",
      "driver_billing_incomplete_warning": "Para poder generar tus facturas, necesitas completar todos los campos de facturación. Haz click en \"Editar\" para actualizar tu información.",
      "driver_my_documents": "Mis Documentos",
      "driver_docs_progress": "Progreso: {{uploaded}} de {{total}} documentos subidos",
      "driver_upload_document": "Subir Documento",
      "driver_doc_license_front": "Carnet de Conducir (Frontal)",
      "driver_doc_license_back": "Carnet de Conducir (Reverso)",
      "driver_doc_dni_front": "DNI/NIE (Frontal)",
      "driver_doc_dni_back": "DNI/NIE (Reverso)",
      "driver_doc_autonomo": "Alta de Autónomo",
      "driver_doc_hacienda": "Corriente de Hacienda",
      "driver_doc_ss": "Corriente de Seguridad Social",
      "driver_doc_uploaded": "Subido:",
      "driver_doc_expires": "Vence:",
      "driver_doc_not_uploaded": "No subido",
      "driver_update": "Actualizar",
      "driver_doc_status_pending": "Pendiente",
      "driver_doc_status_approved": "Aprobado",
      "driver_doc_status_expired": "Vencido",
      "driver_fleet_docs_title": "Documentos de Mis Choferes",
      "driver_fleet_validated": "✓ Validado",
      "driver_billing_my_settlements": "Mis Liquidaciones",
      "driver_billing_subtitle": "Períodos de pago quincenales con desglose completo",
      "driver_billing_periods_info": "Períodos de pago: Quincena 1 (servicios 25-9, pago 10-15) • Quincena 2 (servicios 10-24, pago 25-último)",
      "driver_billing_current_no_services": "Período Actual: Sin servicios",
      "driver_billing_current_no_services_desc": "No tienes servicios aprobados en el período actual. Cuando completes servicios y sean aprobados, aparecerán aquí.",
      "driver_billing_previous_periods": "Períodos Anteriores",
      "driver_billing_no_previous": "No hay liquidaciones anteriores",
      "driver_billing_no_previous_desc": "Cuando se cierre un período y tus servicios sean liquidados, aparecerán aquí",
      "driver_billing_loading_settlements": "Cargando liquidaciones...",
      "driver_billing_loading_period": "Cargando período actual...",
      "driver_billing_in_progress": "EN CURSO",
      "driver_billing_fortnight_1": "Quincena 1",
      "driver_billing_fortnight_2": "Quincena 2",
      "driver_billing_payment_label": "Pago:",
      "driver_billing_services": "Servicios",
      "driver_billing_base": "Base",
      "driver_billing_iva": "IVA (21%)",
      "driver_billing_supplies": "Suplidos",
      "driver_billing_irpf_label": "IRPF",
      "driver_billing_total_accumulated": "TOTAL ACUMULADO",
      "driver_billing_fleet_breakdown": "Desglose por Conductor de Flota:",
      "driver_billing_trips": "viajes",
      "driver_billing_hide_services": "▲ Ocultar Servicios",
      "driver_billing_view_services": "▼ Ver Servicios ({{count}})",
      "driver_billing_totals": "Totales:",
      "driver_billing_driver": "Conductor",
      "driver_billing_rate": "Tarifa",
      "driver_billing_paid": "✓ Pagado",
      "driver_billing_period_breakdown": "Desglose por conductor:",
      "driver_billing_services_count": "servicio(s)",
      "driver_billing_view_services_btn": "Ver Servicios",
      "driver_billing_download_invoice": "Descargar Factura",
      "driver_billing_period_details_title": "Detalles del Período de Facturación",
      "driver_billing_period_label": "Período:",
      "driver_billing_total_trips": "Total Viajes",
      "driver_assign_driver": "Asignar Chofer",
      "driver_reassign_driver": "Reasignar Chofer",
      "driver_urgent": "¡URGENTE!",
      "driver_fleet_manage_subtitle": "Gestiona los conductores de tu flota",
      "driver_fleet_members_title": "Conductores de Flota",
      "driver_fleet_members_count": "{{count}} conductor en tu flota",
      "driver_fleet_members_count_plural": "{{count}} conductores en tu flota",
      "driver_fleet_no_members": "No hay conductores en tu flota",
      "driver_fleet_add_to_start": "Añade conductores para empezar a gestionar tu flota",
      "driver_fleet_add_first": "Añadir Primer Conductor",
      "driver_label_phone_short": "Teléfono:",
      "driver_label_license_no": "Nº Licencia:",
      "driver_status_busy": "Ocupado",
      "driver_status_disconnected": "Desconectado",
      "driver_label_documents": "Documentos:",
      "driver_expense_details_title": "Detalles de Gastos",
      "driver_view_more": "Ver Más",
      "driver_expense_fuel": "Gasolina",
      "driver_expense_tolls": "Peajes",
      "driver_expense_tickets": "Tickets y Recibos",
      "driver_expenses_label": "Gastos",
      "driver_uploading": "Subiendo...",
      "driver_upload_btn": "Subir",
      "driver_dialog_add_fleet_title": "Añadir Conductor a la Flota",
      "driver_dialog_add_fleet_desc": "Crea un nuevo conductor en tu flota.",
      "driver_dialog_basic_info": "Información Básica",
      "driver_dialog_full_name": "Nombre Completo",
      "driver_dialog_license_no": "Nº Carnet de Conducir",
      "driver_dialog_password_note": "📧 Nota: Se generará una contraseña automática y se enviará por email al chofer junto con sus credenciales de acceso.",
      "driver_dialog_docs_optional": "Documentos (Opcional)",
      "driver_dialog_docs_later": "Puedes subir los documentos ahora o el conductor puede subirlos más tarde desde su portal.",
      "driver_dialog_create_driver": "Crear Conductor",
      "driver_dialog_edit_fleet_title": "Editar Conductor de Flota",
      "driver_dialog_edit_fleet_desc": "Actualiza la información del conductor y sube documentos.",
      "driver_dialog_driver_available": "Conductor disponible para recibir servicios",
      "driver_save_changes": "Guardar Cambios",
      "driver_close": "Cerrar",
      "driver_select_driver": "Selecciona Conductor",
      "driver_upload_pickup_photos": "Subir {{count}} Foto(s) de Recogida",
      "driver_upload_delivery_photos": "Subir {{count}} Foto(s) de Entrega",
      "driver_upload_contract_photos": "Subir {{count}} Foto(s) del Contrato",
      "placeholder_select_driver": "Seleccionar conductor",
      "placeholder_amount": "0.00",
      "admin_toast_service_approved_completed": "Servicio aprobado y movido a Completados",
      "admin_toast_error_approve_service": "Error al aprobar el servicio",
      "admin_toast_service_approved": "Servicio aprobado correctamente",
      "admin_toast_service_rejected": "Servicio rechazado",
      "admin_toast_error_reject_service": "Error al rechazar servicio",
      "admin_toast_driver_approved": "Conductor aprobado correctamente",
      "admin_toast_error_approve_driver": "Error al aprobar conductor",
      "admin_toast_complete_distance_and_type": "Completa primero la distancia (km) y tipo de servicio para calcular la tarifa",
      "admin_toast_template_basic_not_found": "No se encontró la plantilla Básica",
      "admin_toast_template_premium_not_found": "No se encontró la plantilla Premium",
      "admin_toast_template_jluis_not_found": "No se encontró la plantilla JLUIS",
      "admin_toast_enter_valid_price": "Introduce un precio válido",
      "admin_toast_select_extra_type": "Selecciona un tipo de extra",
      "admin_toast_price_must_be_positive": "El precio debe ser mayor a 0",
      "admin_toast_extra_added": "Extra añadido",
      "admin_toast_could_not_calculate_rate": "No se pudo calcular la tarifa",
      "admin_toast_error_calculate_price_short": "Error al calcular el precio",
      "login_successful": "¡Inicio de sesión exitoso!",
      "logout_successful": "Sesión cerrada exitosamente",
      "invalid_credentials": "Credenciales inválidas",
      "driver_login_welcome": "¡Bienvenido!",
      "driver_login_error": "Email o contraseña incorrectos",
      "driver_forgot_success": "Se ha enviado una nueva contraseña a tu correo electrónico",
      "driver_forgot_email_not_sent": "Si tu correo está registrado, no pudimos enviar el email. Contacta con soporte.",
      "driver_forgot_error": "No se pudo enviar el correo de recuperación",
      "driver_forgot_send_error": "Error al enviar el correo",
      "driver_forgot_description": "Ingresa tu correo electrónico y te enviaremos una nueva contraseña.",
      "driver_forgot_submit": "Enviar",
      "reset_toast_invalid_token": "Token de recuperación inválido",
      "reset_toast_password_requirements": "La contraseña no cumple con los requisitos de seguridad",
      "reset_toast_error": "Error al restablecer la contraseña",
      "reset_toast_success": "Contraseña restablecida correctamente",
      "reset_title": "Restablecer Contraseña",
      "reset_description": "Ingresa tu nueva contraseña",
      "reset_new_password": "Nueva Contraseña",
      "reset_confirm_password": "Confirmar Contraseña",
      "reset_requirements_title": "Requisitos de contraseña:",
      "reset_req_min_length": "Mínimo 8 caracteres",
      "reset_req_uppercase": "Al menos una mayúscula",
      "reset_req_number": "Al menos un número",
      "reset_req_symbol": "Al menos un símbolo (!@#$%^&*)",
      "reset_passwords_match": "Las contraseñas coinciden",
      "reset_resetting": "Restableciendo...",
      "reset_submit": "Restablecer Contraseña",
      "reset_back_login": "Volver al inicio de sesión",
      "driver_reset_description": "Conductor - Ingresa tu nueva contraseña",
      "reset_network_error": "Error de red",
      "fill_required_fields": "Por favor completa todos los campos requeridos",
      "address_required": "Por favor selecciona una dirección válida",
      "distance_calculating": "Calculando distancia automáticamente...",
    }
  },
  en: {
    translation: {
      // Navigation & Common
      "language": "Language",
      "admin_login": "Admin Login",
      "logout": "Logout",
      "get_started": "Get Started",
      "learn_more": "Learn More",
      "back_to_home": "Back to Home",
      "loading": "Loading...",
      "authenticating": "Authenticating...",
      "please_wait": "Please wait while we log you in.",
      "success": "Success!",
      "redirecting": "Redirecting to dashboard...",
      
      // Landing Page
      "professional_car": "Professional Car",
      "transfer_service": "Transfer Service",
      "landing_description": "Safe, reliable, and efficient car transfer services across Europe. Choose from standard deliveries, B-C services, or trade-in options with transparent distance-based pricing.",
      "realtime_tracking": "Real-time Tracking",
      "realtime_desc": "Monitor your car transfer every step of the way",
      "flexible_timing": "Flexible Timing",
      "flexible_desc": "Set pickup and delivery time margins",
      "secure_payment": "Secure Payment",
      "secure_desc": "Safe transactions via Redsys gateway",
      "clear_pricing": "Clear Pricing",
      "clear_desc": "Distance-based rates shown upfront",
      "why_choose_us": "Why Choose Us?",
      "professional_service": "Professional service you can trust",
      "professional_drivers": "Professional Drivers",
      "drivers_desc": "Our experienced and vetted drivers ensure your vehicle is in safe hands throughout the journey.",
      "fully_insured": "Fully Insured",
      "insured_desc": "Complete insurance coverage for your peace of mind during the entire transfer process.",
      "transparent_pricing": "Transparent Pricing",
      "transparent_desc": "No hidden fees. Clear distance-based pricing calculated before you book.",
      
      // Dashboard
      "client_portal": "Client Portal",
      "my_orders": "My Orders",
      "manage_orders": "Manage your car transfer requests",
      "create_order": "Create Order",
      "no_orders_yet": "No orders yet",
      "create_first_order": "Create your first car transfer order to get started",
      "search_by_plate": "Search by Plate",
      "enter_plate_number": "Enter plate number...",
      "no_orders_found": "No orders found",
      "try_different_search": "Try a different search",
      "try_different_filters": "Try adjusting the search filters",
      "filter_orders": "Filter Orders",
      "filter_description": "Use filters to find specific orders",
      "filter_by_city": "Filter by City",
      "all_cities": "All Cities",
      "date_from": "Date From",
      "date_to": "Date To",
      "select_date": "Select date",
      "clear_filters": "Clear Filters",
      "all": "All",
      "order_status": "Order Status",
      "point_c_required": "Point C address required",
      "point_c_information": "Point C Information (Second Delivery)",
      "point_c_address": "Point C Address",
      "first_vehicle": "First Vehicle",
      "second_vehicle": "Second Vehicle",
      "bc_service_note": "First car picked up at A, delivered to B. Then second car picked up at B and delivered to C.",
      "tradein_note": "First car picked up at A, delivered to B. Then second car picked up at B and delivered back to A.",
      "edit_order": "Edit Order",
      "cancel_order": "Cancel Order",
      "show_more": "Show more",
      "show_less": "Show less",
      "dashboard": "Dashboard",
      "my_services": "My Services",
      "create_service": "Create Service",
      "my_company": "My Company",
      "company_profile": "Company Profile",
      "statistics": "Statistics",
      "total_services": "Total Services",
      "in_progress": "In Progress",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "pending_payment": "Pending Payment",
      "total_spent": "Total Spent",
      "recent_services": "Recent Services",
      "upcoming_services": "Upcoming Services",
      "services_by_status": "Services by Status",
      "services_by_type": "Services by Type",
      "financial_summary": "Financial Summary",
      "view_invoices": "View Invoices",
      
      // Profile/Company
      "company_information": "Company Information",
      "company_name": "Company Name",
      "company_name_required": "Company Name *",
      "company_logo": "Company Logo",
      "upload_logo": "Upload Logo",
      "change_logo": "Change Logo",
      "contact_person": "Contact Person",
      "contact_person_required": "Contact Person *",
      "cif_dni": "Tax ID / VAT",
      "cif_dni_required": "Tax ID / VAT *",
      "cif_dni_placeholder": "e.g., B12345678 or 12345678A",
      "phone_number": "Phone Number",
      "phone_required": "Phone Number *",
      "company_address": "Address",
      "address_placeholder": "Complete company address",
      "contact_information": "Contact Information",
      "company_logo_desc": "Upload your company logo to personalize your profile",
      "company_info_billing_desc": "Company and billing information",
      "contact_data_desc": "Contact person details",
      "email_readonly_note": "Email cannot be changed",
      "change_password_section_desc": "Update your access password",
      "email_address": "Email Address",
      "client_no_invoices": "No invoices available",
      "client_invoices_biweekly": "Invoices are generated automatically every 15 days",
      "client_invoices_ondemand": "Payments are processed when creating services",
      "client_address_required": "Address *",
      "client_verification_date": "Verification Date *",
      "client_verification_time": "Verification Time *",
      "client_verification_time_from": "Verification Time - From *",
      "client_verification_time_to": "Verification Time - To *",
      "client_fixed_datetime": "Fixed Date and Time",
      "client_range_datetime": "Date and Time Range",
      "client_switch_to_range": "Switch to Range",
      "client_switch_to_fixed": "Switch to Fixed Date",
      "client_select_date": "Select date",
      "client_address_heading": "Address",
      "client_time_from": "From",
      "client_time_to": "To",
      "service_not_found": "Service not found",
      "no_driver_assigned": "Not assigned",
      "address_not_specified": "Address not specified",
      "no_plate": "No plate",
      "car_type_turismo": "Sedan",
      "back_to_dashboard": "Back to Dashboard",
      "client_financial_summary_desc": "Payment and billing summary",
      "client_pending_services_label": "pending services",
      "client_last_5_services": "Last 5 requested services",
      "client_pickup_label": "Pickup:",
      "client_delivery_label": "Delivery:",
      "client_no_recent_services": "No recent services",
      "client_create_first_service": "Create your first service to get started",
      "billing_information": "Billing Information",
      "security": "Security",
      "change_password": "Change Password",
      "current_password": "Current Password",
      "new_password": "New Password",
      "confirm_password": "Confirm Password",
      "password_requirements": "Minimum 8 characters",
      "save_changes": "Save Changes",
      "profile_updated": "Profile updated successfully",
      "profile_update_error": "Error updating profile",
      "password_updated": "Password updated successfully",
      "password_update_error": "Error updating password",
      "passwords_dont_match": "Passwords don't match",
      "welcome": "Welcome",
      "member_since": "Member since",
      "quick_actions": "Quick Actions",
      "cancellation_policy": "Cancellation and Modification Policy",
      "cancel_policy_1": "• Cancellations in first hour: No cost",
      "cancel_policy_2": "• Cancellations between 1 hour and 24 hours before: 50% of price",
      "cancel_policy_3": "• Cancellations with less than 24 hours: 100% of price",
      "cancel_policy_4": "• Location modifications after 1 hour: €20",
      "cancel_policy_5": "• Changes in first hour: Free",
      "cancel_policy_6": "• Changes during transport: €50 + €0.33/km",
      "cancel_policy_7": "• Changes within 24h prior: €20 + €0.26/km",
      "cancel_policy_8": "• Cancellation during transport: Charged as completed",
      "cancel_policy_9": "• If vehicle unavailable: Charged as completed",
      "confirm_cancel": "Are you sure you want to cancel this order?",
      "order_cancelled": "Order cancelled successfully",
      "order_updated": "Order updated successfully",
      
      // Order Form
      "create_new_order": "Create New Transfer Order",
      "fill_details": "Fill in the details for your car transfer request",
      "service_type": "Service Type",
      "service_type_required": "Select a service type *",
      "delivery": "Delivery",
      "delivery_desc": "Standard single vehicle transport from point A to point B.",
      "bc_service": "B-C Service",
      "bc_service_desc": "Multiple Destinations: Pick up at A, deliver at B and pick up at B to deliver at C (20% discount on 2nd vehicle).",
      "tradein": "TRADE-IN",
      "tradein_desc": "Vehicle Exchange: Pick up at A, deliver at B and pick up at B to return at A (30% discount on 2nd vehicle).",
      "representacion": "Representation",
      "representacion_desc": "On-site verification",
      
      // Pickup Information
      "pickup_information": "Pickup Information",
      "pickup_address": "Pickup Address *",
      "start_typing_address": "Start typing address...",
      "contact_name": "Contact Name *",
      "contact_phone": "Contact Phone *",
      "pickup_date_range": "Pickup Date Range *",
      "select_dates": "Select dates",
      "pickup_time": "Pickup Time *",
      "select_time": "Select time",
      
      // Delivery Information
      "delivery_information": "Delivery Information",
      "delivery_address": "Delivery Address *",
      "delivery_date_range": "Delivery Date Range *",
      "delivery_time": "Delivery Time *",
      
      // Vehicle Information
      "vehicle_information": "Vehicle Information",
      "vehicle_type": "Vehicle Type *",
      "select_vehicle_type": "Select vehicle type",
      "car": "Sedan",
      "van": "Van",
      "pickup_truck": "Truck < 3.500kg",
      "sport_car": "Sports Car",
      "suv": "SUV",
      "motorcycle": "Motorcycle",
      "brand": "Brand *",
      "model": "Model *",
      "license_plate": "License Plate *",
      "fuel_type": "Fuel Type *",
      "select_fuel_type": "Select fuel type",
      "electric": "Electric",
      "hybrid": "Hybrid",
      "diesel": "Diesel",
      "gasoline": "Gasoline",
      
      // Second Vehicle
      "second_vehicle_optional": "Second Vehicle (Optional)",
      "second_vehicle_desc": "For B-C service or trade-in",
      "add_second_vehicle": "Add Second Vehicle",
      "remove_second_vehicle": "Remove Second Vehicle",
      
      // Representación fields
      "buyer_data": "Buyer Information",
      "seller_data": "Seller Information",
      "buyer_name": "Buyer Name",
      "buyer_surname": "Buyer Surname",
      "buyer_phone": "Buyer Phone",
      "buyer_dni": "Buyer ID/NIE",
      "seller_name": "Seller Name",
      "seller_surname": "Seller Surname",
      "seller_phone": "Seller Phone",
      "seller_dni": "Seller ID/NIE",
      "verification_address": "Verification Address",
      "verification_date": "Verification Date",
      "verification_time": "Verification Time",
      "enter_verification_address": "Enter the address where the vehicle will be verified",
      
      // Additional Services
      "additional_services": "Additional Services",
      "select_additional_services": "Select additional services if needed",
      "exterior_cleaning": "Exterior Cleaning",
      "interior_cleaning": "Interior Cleaning",
      "waiting_period": "Waiting Period",
      "itv_inspection": "ITV Inspection",
      "pit_stop": "Pit Stop",
      
      // Distance & Pricing
      "distance_pricing": "Distance & Pricing",
      "calculated_distance": "Calculated Distance",
      "calculating": "Calculating...",
      "base_price": "Base Price",
      "additional_services_total": "Additional Services Total",
      "total_price": "Total Price",
      "notes": "Notes (Optional)",
      "notes_placeholder": "Any additional information...",
      
      // Actions
      "cancel": "Cancel",
      "create": "Create",
      "update_order": "Save Changes",
      "update": "Update",
      "delete": "Delete",
      "edit": "Edit",
      "pay_now": "Pay Now",
      "calculate_price": "Calculate Price",
      
      // Order Status
      "status": "Status",
      "pending": "Awaiting Assignment",
      "confirmed": "Confirmed",
      "assigned": "Assigned",
      "in_transit": "In Transit",
      "delivered": "Completed",
      "cancelled": "Cancelled",
      "Cancelado en Garantía": "Cancelled with Guarantee",
      "Cancelado con -24h antelación": "Cancelled with <24h notice",
      "Cancelado con +24h de antelación": "Cancelled with >24h notice",
      "pending": "Pending",
      "paid": "Paid",
      "failed": "Failed",
      
      // Admin
      "admin_portal": "Admin Portal",
      "dashboard": "Dashboard",
      "overview": "Overview",
      "orders": "Orders",
      "drivers": "Drivers",
      "pricing": "Pricing",
      "total_orders": "Total Orders",
      "pending_orders": "Pending Orders",
      "total_drivers": "Total Drivers",
      "total_revenue": "Total Revenue",
      "recent_orders": "Recent Orders",
      "orders_management": "Orders Management",
      "drivers_management": "Drivers Management",
      "pricing_management": "Pricing Management",
      "search_by_client": "Search by client",
      "search_by_plate": "Search by plate",
      "filter_by_status": "Filter by status",
      "filter_by_city": "Filter by city",
      "filter_by_date": "Filter by date",
      "from_date": "From date",
      "to_date": "To date",
      "all_statuses": "All statuses",
      "all_cities": "All cities",
      "update_order": "Update Order",
      "edit_order_details": "Edit Order Details",
      "assign_driver": "Assign Driver",
      "no_driver": "No driver",
      "update": "Update",
      "save_changes": "Save Changes",
      "cancel": "Cancel",
      "pickup_address": "Pickup Address",
      "delivery_address": "Delivery Address",
      "client_info": "Client Information",
      "service_details": "Service Details",
      "add_driver": "Add Driver",
      "driver_name": "Driver Name",
      "driver_phone": "Driver Phone",
      "driver_status": "Driver Status",
      "available": "Available",
      "busy": "Busy",
      "offline": "Offline",
      "add_pricing_rate": "Add Pricing Rate",
      "distance_range": "Distance Range",
      "min_distance": "Min Distance (km)",
      "max_distance": "Max Distance (km)",
      "price_per_km": "Price per km",
      "base_fee": "Base Fee",
      "example_price": "Example Price (100km)",
      "actions": "Actions",
      "edit": "Edit",
      "delete": "Delete",
      "view_details": "View Details",
      "filters": "Filters",
      "clear_filters": "Clear Filters",
      "apply_filters": "Apply Filters",
      "results": "results",
      "no_results": "No results found",
      "view_manage_orders": "View and manage all car transfer orders",
      "pickup": "Pickup",
      "delivery": "Delivery",
      "vehicle": "Vehicle",
      "distance": "Distance",
      "price": "Price",
      "assigned_driver": "Assigned Driver",
      "service_type": "Service Type",
      "car_brand": "Brand",
      "car_model": "Model",
      "car_plate": "Plate",
      "fuel_type": "Fuel Type",
      "pickup_contact": "Pickup Contact",
      "delivery_contact": "Delivery Contact",
      "contact_name": "Contact Name",
      "contact_phone": "Contact Phone",
      "pickup_date": "Pickup Date",
      "delivery_date": "Delivery Date",
      "no_delivery_date": "No delivery date",
      "manage_driver_fleet": "Manage your driver fleet",
      "information": "Information",
      "modify_order_information": "Modify order information",
      "payment_status": "Payment Status",
      "monitor_performance": "Monitor your car transfer service performance",
      "client": "Client",
      "route": "Route",
      "service": "Service",
      "filter_by_payment": "Filter by payment status",
      "filter_by_driver": "Filter by driver",
      "no_driver_assigned": "No driver assigned",
      "all_drivers": "All drivers",
      "search_driver": "Search driver...",
      "create_new_driver": "Create new driver",
      "type_to_search": "Type to search...",
      "driver_info": "Driver Information",
      "driver_phone": "Driver Phone",
      "driver_dni": "Driver ID/DNI",
      
      // Admin Dashboard (sidebar, stats, kanban, sub-admins)
      "admin_calendar": "Calendar",
      "admin_management": "Management",
      "admin_pricing_section": "Pricing",
      "admin_general_pricing": "General Pricing",
      "admin_driver_pricing": "Driver Pricing",
      "admin_custom_pricing": "Custom Pricing",
      "admin_billing": "Billing",
      "admin_client_invoices": "Client Invoices",
      "admin_driver_invoices": "Driver Invoices",
      "admin_approvals": "Approvals",
      "admin_administration": "Administration",
      "admin_profiles": "Profiles",
      "admin_documents": "Documents",
      "admin_collaborators": "Collaborators",
      "admin_close_sidebar": "Close menu",
      "admin_services_in_progress": "Services in Progress",
      "admin_total_services_done": "Total Services Done",
      "admin_pending_closure": "Pending Closure (Drivers)",
      "admin_services_completed": "Services Completed",
      "admin_pending_payment": "Pending Payment",
      "admin_services_paid": "Services Paid",
      "admin_pending_approvals": "Pending Approvals",
      "admin_total_revenue": "Total Revenue",
      "admin_kanban_new": "New",
      "admin_kanban_new_subtitle": "No driver assigned",
      "admin_kanban_assigned": "Assigned",
      "admin_kanban_assigned_subtitle": "En route / In progress",
      "admin_kanban_pending_approval": "Pending Approval",
      "admin_kanban_pending_approval_subtitle": "Awaiting validation",
      "admin_kanban_completed": "Completed",
      "admin_kanban_completed_subtitle": "Pending history",
      "admin_no_client": "No client",
      "admin_unassigned": "Unassigned",
      "admin_status_pending": "Pending",
      "admin_status_assigned": "Assigned",
      "admin_status_in_progress": "In Progress",
      "admin_status_in_transit": "In Transit",
      "admin_status_delivered": "Delivered",
      "admin_status_cancelled": "Cancelled",
      "admin_payment_pending": "Payment Pending",
      "admin_payment_paid": "Paid",
      "admin_payment_failed": "Payment Failed",
      "admin_client_label": "Client:",
      "admin_driver_label": "Driver:",
      "admin_price_client": "Client Price:",
      "admin_price_driver": "Driver Price:",
      "admin_distance": "Distance:",
      "admin_photos_pickup": "Pickup Photos",
      "admin_photos_delivery": "Delivery Photos",
      "admin_expenses": "Expenses",
      "admin_open": "Open",
      "admin_complete": "Complete",
      "admin_history": "History",
      "admin_revert": "Revert",
      "admin_revert_title": "Revert to In Progress to modify expenses",
      "admin_photos": "Photos",
      "admin_contract": "Contract",
      "admin_calendar_btn": "Calendar",
      "admin_delete": "Delete",
      "admin_cancel": "Cancel",
      "admin_cancel_at_pickup": "Pickup",
      "admin_cancel_at_pickup_title": "Vehicle not available at pickup",
      "admin_cancel_in_transit": "Transit",
      "admin_cancel_in_transit_title": "Cancelled during transport",
      "admin_approve_cancellation": "Approve Cancellation",
      "admin_filters": "Filters",
      "admin_filter_client": "Client",
      "admin_search_client_placeholder": "Search client...",
      "admin_plate": "Plate",
      "admin_plate_placeholder": "Plate...",
      "admin_city": "City",
      "admin_city_placeholder": "City...",
      "admin_driver_filter": "Driver",
      "admin_from": "From",
      "admin_to": "To",
      "admin_clear_filters": "Clear",
      "admin_all": "All",
      "admin_kanban_tip": "Drag cards between columns to change service status",
      "admin_services_in_process": "services in progress",
      "admin_drop_here": "Drop here",
      "admin_no_services": "No services",
      "admin_confirm_action": "Confirm Action",
      "admin_approve_service": "Approve Service",
      "admin_approve_service_message": "Do you confirm you want to approve service #{{id}}? The service will move to Completed.",
      "admin_revert_state": "Revert State",
      "admin_revert_state_message": "Do you want to move service #{{id}} back to \"{{target}}\"? This will open the edit dialog to make the necessary changes.",
      "admin_confirm": "Confirm",
      "admin_subadmins_title": "Collaborator Management",
      "admin_subadmins_desc": "Create and manage users with limited access to the system",
      "admin_new_collaborator": "New Collaborator",
      "admin_what_is_collaborator": "What is a Collaborator?",
      "admin_collaborator_bullet1": "Can only see the drivers and services you assign to them",
      "admin_collaborator_bullet2": "Can assign rates only to the drivers they manage",
      "admin_collaborator_bullet3": "By default, cannot see client prices or delete anything",
      "admin_collaborator_bullet4": "Can create new services and manage photos/documents for their drivers",
      "admin_loading_collaborators": "Loading collaborators...",
      "admin_no_collaborators": "No collaborators created",
      "admin_create_first_collaborator": "Create a new collaborator to get started",
      "admin_see_prices": "Sees client prices",
      "admin_no_see_prices": "Does not see client prices",
      "admin_see_unassigned": "Sees unassigned",
      "admin_no_see_unassigned": "Does not see unassigned",
      "admin_can_delete": "Can delete",
      "admin_cannot_delete": "Cannot delete",
      "admin_drivers_count": "drivers",
      "admin_services_count": "services",
      "admin_assigned_drivers": "Assigned drivers:",
      "admin_assigned_services_unassigned": "Assigned services (no driver):",
      "admin_edit": "Edit",
      "admin_services": "Services",
      "admin_create_collaborator": "Create New Collaborator",
      "admin_name_required": "Name *",
      "admin_name_placeholder": "Collaborator name",
      "admin_email_required": "Email *",
      "admin_email_placeholder": "collaborator@company.com",
      "admin_password_required": "Password *",
      "admin_password_placeholder": "Minimum 8 characters",
      "admin_admin_type": "Admin Type",
      "admin_permissions": "Permissions",
      "admin_can_see_prices_invoices": "Can see client prices, rates and invoices",
      "admin_includes_prices_note": "Includes: Pricing, Client Invoices, Profiles, price column",
      "admin_can_see_unassigned_services": "Can see unassigned services",
      "admin_can_delete_services": "Can delete services and drivers",
      "admin_assigned_drivers_required": "Assigned Drivers *",
      "admin_all_drivers": "All",
      "admin_none": "None",
      "admin_search_driver_placeholder": "Search driver...",
      "admin_no_drivers_available": "No drivers available",
      "admin_drivers_selected": "driver(s) selected",
      "admin_create_collaborator_btn": "Create Collaborator",
      "admin_edit_collaborator": "Edit Collaborator",
      "admin_email_readonly": "Email cannot be changed",
      "admin_save_changes": "Save Changes",
      "admin_assign_services_to": "Assign Services to",
      "admin_assign_services_note": "Only services with no driver assigned are shown. Services with an assigned driver are automatically filtered by the collaborator's drivers.",
      "admin_search_service_placeholder": "Search by city, client or ID...",
      "admin_no_unassigned_services": "No unassigned services available",
      "admin_services_selected": "service(s) selected",
      "admin_save_services": "Save Services",
      "admin_super_admin": "Main Administrator",
      "admin_full": "Full Admin",
      "admin_sub_admin": "Collaborator",
      "admin_sub_admin_option": "Collaborator (Limited access)",
      "admin_full_option": "Full Admin (Sees all)",
      "admin_driver_not_found": "Driver not found",
      "admin_service_not_found": "Service not found",
      "admin_error_load_collaborators": "Error loading collaborators",
      "admin_error_create_collaborator": "Error creating collaborator",
      "admin_error_update_collaborator": "Error updating collaborator",
      "admin_error_delete_collaborator": "Error deleting collaborator",
      "admin_error_assign_services": "Error assigning services",
      "admin_confirm_delete_collaborator": "Are you sure you want to delete this collaborator?",
      "admin_fill_required": "Please complete all required fields",
      "admin_assign_at_least_one_driver": "You must assign at least one driver to the collaborator",
      "admin_charge_espera": "Waiting",
      "admin_charge_pit_stop": "Pit Stop",
      "admin_charge_itv": "ITV",
      "admin_charge_express": "Express",
      "admin_charge_recogida_extra": "Extra Pickup",
      "admin_charge_cambio_ruta": "Route Change",
      "admin_charge_otros": "Other",
      "admin_toast_periods_generated": "Periods generated successfully",
      "admin_toast_error_load_periods": "Error loading billing periods",
      "admin_toast_error_generate_periods": "Error generating billing periods",
      "admin_toast_error_create_invoice": "Error creating invoice",
      "admin_toast_service_marked_paid": "Service marked as paid",
      "admin_toast_error_mark_paid": "Error marking service as paid",
      "admin_toast_invoice_marked_paid": "Invoice marked as paid",
      "admin_toast_error_invoice_paid": "Error marking invoice as paid",
      "admin_toast_collaborator_created": "Collaborator created successfully",
      "admin_toast_collaborator_created_no_email": "Collaborator created. Welcome email could not be sent; share credentials manually.",
      "admin_toast_collaborator_updated": "Collaborator updated successfully",
      "admin_toast_collaborator_deleted": "Collaborator deleted successfully",
"admin_toast_services_assigned": "Services assigned successfully",
      "admin_table_service_id": "Service ID",
      "admin_table_client": "Client",
      "admin_table_plate": "Plate",
      "admin_table_pickup": "Pickup",
      "admin_table_delivery": "Delivery",
      "admin_table_dates": "Dates",
      "admin_table_driver": "Driver",
      "admin_table_status": "Status",
      "admin_table_price": "Price",
      "admin_table_action": "Action",
      "calendar_title": "Service Calendar",
      "calendar_subtitle": "All services organized by pickup date",
      "calendar_no_driver": "No driver",
      "calendar_in_progress": "In progress",
      "calendar_completed": "Completed",
      "calendar_others": "Others",
      "calendar_origin": "Origin:",
      "calendar_destination": "Destination:",
      "calendar_driver": "Driver:",
      "calendar_client": "Client:",
      "calendar_price": "Price:",
      "timezone_label": "Time zones (to align agenda)",
      "timezone_configure": "Configure",
      "timezone_zone1_label": "Zone 1 label (e.g. Me, Madrid, Client)",
      "timezone_zone2_label": "Zone 2 label (e.g. Assistant, Bangkok, Team)",
      "timezone_zone1_placeholder": "Zone 1",
      "timezone_zone2_placeholder": "Zone 2",
      "timezone_search_placeholder": "Search zone...",
      "timezone_help": "Calendar times are shown in both zones. Choose any two zones (e.g. you and your assistant) to align agendas.",
      "timezone_save": "Save",
      "admin_services_in_progress_tab": "In progress",
      "admin_historical": "Historical",
      "admin_list": "List",
      "admin_creation": "Creation:",
      "admin_rate_assigned_driver": "Rate assigned to driver:",
      "admin_rate_suggestions_driver": "Rate suggestions for driver:",
      "admin_rate_for_driver_incomplete": "Rates for driver (complete distance and type):",
      "admin_basic": "Basic",
      "admin_active": "Active",
      "admin_custom": "Custom",
      "admin_customized": "Customized",
      "admin_approve": "Approve",
      "admin_complete_service_title": "Complete service with photos and expenses",
      "admin_delete_service_title": "Delete service permanently",
      "admin_view_history_title": "View completed service details",
      "admin_cancel_normal_title": "Normal cancellation (by time)",
      "admin_calculated_distance": "Calculated Distance",
      "admin_not_calculated": "Not calculated",
      "admin_additional_services": "Additional Services",
      "admin_service_notes": "Service Notes",
      "admin_notes_general": "General:",
      "admin_notes_vehicle1": "Vehicle 1:",
      "admin_notes_vehicle2": "Vehicle 2:",
      "admin_view_photos": "View Photos",
      "admin_view_expenses": "View Expenses",
      "admin_no_photos_for_service": "No photos available for this service.",
      "admin_no_expenses_for_service": "No expenses reported for this service.",
      "admin_service_expenses": "Service Expenses",
      "admin_close": "Close",
      "admin_no_receipts_attached": "No receipts attached to this report",
      "admin_table_name": "Name",
      "admin_table_phone": "Phone",
      "admin_table_email": "Email",
      "admin_table_license": "License",
      "admin_table_actions": "Actions",
      "admin_driver_status_required": "Status *",
      "admin_driver_busy": "Busy",
      "admin_driver_offline": "Offline",
      "admin_toast_driver_created_ok": "Driver created successfully.",
      "admin_toast_driver_docs_uploaded": "{{count}} document(s) uploaded.",
      "admin_toast_driver_welcome_email_sent": "Welcome email sent.",
      "admin_service_expenses_subtitle": "Service #{{id}} - {{brand}} {{model}}",
      "admin_add_to_calendar": "Add to Calendar",
      "admin_download_contract": "Download Contract",
      "admin_premium": "Premium",
      "admin_toast_opening_calendar": "Opening Google Calendar...",
      "admin_toast_contract_downloaded": "Contract downloaded - 2 pages: Driver and Client",
      "admin_toast_error_generate_contract": "Error generating contract",
      "admin_toast_error_download_contract": "Error downloading contract",
      "pagination_showing": "Showing",
      "pagination_to": "to",
      "pagination_of": "of",
      "pagination_results": "results",
      "pagination_prev": "Previous",
      "pagination_next": "Next",
      "pagination_page_of": "Page {{current}} of {{total}}",
      "driver_profile_title": "Driver Profile",
      "driver_profile_subtitle": "Detailed information, documents and statistics",
      "driver_basic_info": "Basic Information",
      "driver_upload_new": "Upload New",
      "driver_upload_new_document": "Upload New Document",
      "driver_statistics": "Statistics",
      "driver_total_services": "Total Services",
      "driver_completed": "Completed",
      "driver_earnings": "Earnings",
      "driver_billing_info": "Billing Information",
      "driver_doc_not_uploaded": "Not uploaded",
      "driver_doc_expires_soon": "Expires Soon",
      "driver_doc_approved": "Approved",
      "driver_doc_pending": "Pending",
      "driver_doc_rejected": "Rejected",
      "driver_doc_expired": "Expired",
      "driver_doc_dni_front": "ID - Front",
      "driver_doc_dni_back": "ID - Back",
      "driver_doc_license_front": "License - Front",
      "driver_doc_license_back": "License - Back",
      "driver_doc_autonomo": "Self-Employed Certificate",
      "driver_doc_hacienda": "Tax Certificate",
      "driver_doc_ss": "Social Security",
      "driver_error_open_document": "Error opening document",
      "driver_validated": "Validated",
      "driver_subidos_required": "uploaded of {{required}} required",
      "admin_edit_driver": "Edit Driver",
      "admin_edit_driver_description": "Modify the driver's information. Admin can edit everything.",
      "admin_label_name": "Name",
      "admin_label_email": "Email",
      "admin_label_phone": "Phone",
      "admin_label_dni_nif": "DNI/NIF",
      "admin_driver_available": "Driver available",
      "admin_documents_validated": "Documents Validated",
      "admin_billing_full_name": "Full Name *",
      "admin_billing_legal_name_hint": "Full legal name for invoices",
      "admin_billing_dni_nie": "ID or NIE *",
      "admin_billing_irpf": "IRPF Withholding (%)",
      "admin_billing_irpf_hint": "Percentage of IRPF to withhold (0-100%)",
      "admin_billing_fiscal_address": "Full Tax Address *",
      "admin_billing_bank_name": "Bank Name *",
      "admin_billing_iban": "Account Number (IBAN) *",
      "admin_driver_type": "Driver Type",
      "admin_fleet_driver": "Driver with Fleet",
      "admin_fleet_driver_hint": "Fleet drivers can create and manage other drivers under their supervision.",
      "admin_assign_fleet": "Assign to Fleet (Optional)",
      "admin_independent_driver": "Independent Driver",
      "admin_fleet_assign_hint": "If you select a fleet, this driver will be under the supervision of the selected fleet driver",
      "admin_add_new_driver": "Add New Driver",
      "admin_enter_driver_info": "Enter driver information",
      "admin_license_number": "License Number",
      "admin_name_label": "Name",
      "admin_vehicle_info_label": "Vehicle Information",
      "admin_drivers_management": "Drivers Management",
      "admin_manage_driver_fleet": "Manage your driver fleet",
      "admin_clients_management": "Clients Management",
      "admin_clients_detail": "Detailed information for all clients",
      "admin_drivers_detail": "Detailed information for all drivers",
      "admin_drivers_assigned_desc": "Drivers assigned to you or that you have created",
      "admin_drivers_assigned": "Assigned",
      "admin_drivers_registered": "Registered",
      "admin_drivers_assigned_title": "Assigned Drivers",
      "admin_drivers_registered_title": "Registered Drivers",
      "admin_create_driver": "Create Driver",
      "admin_billing_info": "Billing Information",
      "admin_delivery_info": "Delivery Information",
      "admin_driver_docs_title": "Driver Documentation",
      "admin_validation_pending": "Validation Pending",
      "admin_docs_warning_title": "Attention: Validated driver without documents",
      "admin_docs_warning_body": "This driver is marked as \"Validated\" but has no documents uploaded to the system. Please upload the corresponding documents to keep records correct.",
      "admin_fleet_driver_info": "Fleet Driver: Only requires Driver's License and ID (4 basic documents)",
      "admin_independent_driver_info": "Independent/Fleet Owner Driver: Requires all documents (7 total)",
      "admin_docs_upload_note": "When uploading documents as admin, they are validated automatically. Maximum 5MB per file.",
      "admin_docs_uploaded_count": "Uploaded Documents ({{count}})",
      "admin_docs_basic": "Basic Documents (Mandatory)",
      "admin_docs_certificates": "Additional Certificates (Independent and Fleet Owner Drivers Only)",
      "admin_expiry_date": "Expiration Date",
      "admin_format_image_pdf": "Format: JPG, PNG or PDF (max. 5MB)",
      "admin_format_pdf": "Format: PDF (max. 5MB)",
      "admin_uploaded": "Uploaded",
      "admin_expires": "Expires",
      "admin_expired": "EXPIRED",
      "admin_expires_soon": "EXPIRES SOON",
      "admin_docs_no_delete": "Documents cannot be deleted. To replace a document, upload a new one of the same type.",
      "admin_uploading_doc": "Uploading document...",
      "admin_doc_license_front_full": "Driver's License (Front)",
      "admin_doc_license_back_full": "Driver's License (Back)",
      "admin_doc_dni_front_full": "ID (Front)",
      "admin_doc_dni_back_full": "ID (Back)",
      "admin_doc_autonomo_full": "Self-Employed Registration",
      "admin_doc_ss_full": "Current Social Security Certificate",
      "admin_doc_hacienda_full": "Current Tax Agency Certificate",
      "admin_general_pricing_title": "General Client Rates",
      "admin_general_pricing_description": "These rates apply by default to all clients",
      "admin_add_pricing_rate": "Add Pricing Rate",
      "admin_edit_pricing_rate": "Edit Pricing Rate",
      "admin_add_new_pricing_rate": "Add New Pricing Rate",
      "admin_configure_pricing_description": "Configure pricing for distance range",
      "admin_min_distance_km": "Minimum Distance (km)",
      "admin_max_distance_km": "Maximum Distance (km)",
      "admin_price_delivery": "Delivery Service Price (€)",
      "admin_price_bc": "B-C Service Price (€)",
      "admin_price_tradein": "TRADE-IN Service Price (€)",
      "admin_price_representation": "Representation Service Price (€)",
      "admin_per_km_section": "Prices per additional km (optional - for 1001+ km ranges)",
      "admin_per_km_delivery": "Delivery - Price per additional km (€)",
      "admin_per_km_bc": "B-C - Price per additional km (€)",
      "admin_per_km_tradein": "TRADE-IN - Price per additional km (€)",
      "admin_per_km_note": "If defined, price will be: base + (km - 1001) × this value",
      "admin_placeholder_040": "e.g. 0.40",
      "admin_placeholder_032": "e.g. 0.32",
      "admin_placeholder_028": "e.g. 0.28",
      "admin_pricing_table_title": "General Client Rates Table",
      "admin_pricing_table_description": "By default, all clients use these rates",
      "admin_pricing_col_distance": "Distance (km)",
      "admin_pricing_col_delivery": "Delivery (€)",
      "admin_pricing_col_bc": "B-C Service (€)",
      "admin_pricing_col_tradein": "TRADE-IN (€)",
      "admin_pricing_col_representation": "Representation (€)",
      "admin_pricing_col_actions": "Actions",
      "admin_no_rates_configured": "No rates configured. Click \"Add Pricing Rate\" to create one.",
      "admin_per_km_suffix": "additional km",
      "admin_additional_services_title": "Additional Services",
      "admin_additional_services_description": "Rates for extra services available to all clients",
      "admin_add_service": "Add Service",
      "admin_edit_additional_service": "Edit Additional Service",
      "admin_new_additional_service": "New Additional Service",
      "admin_edit_additional_service_desc": "Modify the service details",
      "admin_new_additional_service_desc": "Add a new additional service",
      "admin_service_name_label": "Service Name",
      "admin_service_name_placeholder": "e.g. Exterior Cleaning",
      "admin_service_price_label": "Price (€)",
      "admin_billing_unit_label": "Billing Unit",
      "admin_unit_per_service": "Per Service",
      "admin_unit_per_hour": "Per Hour",
      "admin_unit_per_vehicle": "Per Vehicle",
      "admin_service_description_label": "Description",
      "admin_service_description_placeholder": "Service description",
      "admin_additional_services_col_service": "Service",
      "admin_additional_services_col_price": "Price (€)",
      "admin_additional_services_col_unit": "Unit",
      "admin_additional_services_col_description": "Description",
      "admin_additional_services_col_actions": "Actions",
      "admin_no_additional_services": "No additional services configured",
      "admin_driver_pricing_title": "Rates for Drivers",
      "admin_driver_pricing_subtitle": "Manage the rates paid to drivers for their services",
      "admin_new_template": "New Template",
      "admin_view_rates": "View Rates",
      "admin_badge_high_end": "High end",
      "admin_badge_standard": "Standard",
      "admin_badge_premium_plus_10": "Premium +10%",
      "admin_how_tariff_system_works": "How the pricing system works",
      "admin_basic_tariff_explanation": "Basic: Standard rate for most services",
      "admin_premium_tariff_explanation": "Premium: Superior rate with better margins",
      "admin_jluis_tariff_explanation": "JLUIS: Premium rate + 10% additional (automatically calculated)",
      "admin_tariff_assignment_explanation": "When assigning a driver to a service, the admin chooses the applicable rate",
      "admin_custom_tariff_explanation": "A custom rate can also be entered for special cases",
      "admin_tariff_comparison_title": "Rate Comparison (Example: 500 km)",
      "admin_tariff_comparison_subtitle": "Approximate prices for 500 km services",
      "admin_standard_delivery": "Standard delivery",
      "admin_superior_delivery": "Superior delivery",
      "admin_premium_plus_10_label": "Premium + 10%",
      "admin_pricing_disclaimer": "* Exact prices vary according to distance and service type",
      "admin_services_with": "Services with {{name}}",
      "admin_error_load_rates": "Error loading rates",
      "admin_rates_for_template": "Rates - {{name}}",
      "admin_all_rates_configured_for_template": "All rates configured for this template",
      "admin_range_km": "Range (km)",
      "admin_rates_col_delivery": "Delivery",
      "admin_rates_col_bc": "B-C",
      "admin_rates_col_tradein": "Trade-In",
      "admin_rates_col_representation": "Representation",
      "admin_rates_col_actions": "Actions",
      "admin_base_plus_per_km": "Base + additional per km",
      "admin_no_rates_for_template": "No rates configured for this template",
      "admin_create_new_pricing_template": "Create New Pricing Template",
      "admin_new_template_intro": "The new template will be created with the same rates as the Basic template. You can edit them later.",
      "admin_template_name_required": "Template Name *",
      "admin_template_name_placeholder": "e.g. Premium Plus, Special, etc.",
      "admin_template_description_placeholder": "Brief description of this template",
      "admin_note": "Note:",
      "admin_new_template_note_body": "The new template will be created automatically with 17 rate ranges (based on the Basic template). You will be able to edit them individually after creating it.",
      "admin_create_template": "Create Template",
      "admin_creating": "Creating...",
      "admin_assign_rate": "Assign Rate",
      "admin_create_new_template_singular": "Create New Pricing Template",
      "admin_define_template_desc": "Define a name and description for the new pricing template",
      "admin_template_placeholder_vip": "e.g. VIP Rate Madrid",
      "admin_template_description_optional": "Description (optional)",
      "admin_template_placeholder_special": "e.g. Special rate for VIP clients in Madrid",
      "admin_no_custom_templates": "No custom templates.",
      "admin_click_new_template_to_create": "Click \"New Template\" to create one.",
      "admin_custom_pricing_clients_title": "Custom Client Rates",
      "admin_custom_pricing_subtitle": "Manage rate templates and assign them to specific clients",
      "admin_clients_and_assigned_rates": "Clients and their Assigned Rates",
      "admin_clients_assigned_rates_description": "All registered clients and the rate they are using",
      "admin_no_clients_registered": "No clients registered",
      "admin_assigned_rate": "Assigned Rate",
      "admin_general_rate": "General Rate",
      "admin_custom_rate": "Custom Rate",
      "admin_change": "Change",
      "admin_email_header": "Email",
      "admin_default_badge": "Default",
      "admin_standard_rate_default": "Standard rate applied by default to all clients",
      "admin_clients_count": "{{count}} clients",
      "admin_available_rate_templates": "Available Rate Templates",
      "admin_manage_templates_assign_clients": "Manage the rate templates you can assign to clients",
      "admin_distance_ranges": "Distance Ranges",
      "admin_add_rate": "Add Rate",
      "admin_add_rate_to": "Add Rate to {{name}}",
      "admin_add_rate_dialog_desc": "Define a distance range and prices for each service type",
      "admin_price_delivery_eur": "Delivery Price (€)",
      "admin_price_bc_eur": "B-C Price (€)",
      "admin_price_tradein_eur": "TRADE-IN Price (€)",
      "admin_price_representation_eur": "Representation Price (€)",
      "admin_template_clidrive_name": "Clidrive Rate",
      "admin_template_clidrive_description": "Special rates for Clidrive",
      "admin_client_invoices_subtitle": "Manage and generate invoices for client services",
      "admin_generate_invoices": "Generate Invoices",
      "admin_current_period_in_progress": "Current Period - IN PROGRESS",
      "admin_services_period": "Services: {{start}} - {{end}}",
      "admin_billing_expected": "Expected billing: {{start}} - {{end}}",
      "admin_no_services_pending_invoice": "No services pending to invoice",
      "admin_metric_clients": "Clients",
      "admin_metric_services": "Services",
      "admin_taxable_base": "Taxable Base",
      "admin_total_with_vat": "Total with VAT",
      "admin_invoices_col_client": "CLIENT",
      "admin_invoices_col_services": "SERVICES",
      "admin_invoices_col_base": "BASE",
      "admin_invoices_col_iva": "VAT (21%)",
      "admin_invoices_col_total": "TOTAL",
      "admin_invoices_col_actions": "ACTIONS",
      "admin_view_detail": "View Detail",
      "admin_hide": "Hide",
      "admin_services_detail": "Service Details",
      "admin_invoices_col_date": "DATE",
      "admin_invoices_col_plate": "PLATE",
      "admin_invoices_col_vehicle": "VEHICLE",
      "admin_invoices_col_type": "TYPE",
      "admin_invoices_col_extras": "EXTRAS",
      "admin_nif_label": "VAT ID",
      "admin_generate_client_invoices_title": "Generate Client Invoices",
      "admin_generate_client_invoices_desc": "Generate invoices for the selected period. Only delivered services will be included.",
      "admin_fortnight_type": "Fortnight Type",
      "admin_quincena_1_option": "Fortnight 1 (Serv. 25-9 → Invoice 10-15)",
      "admin_quincena_2_option": "Fortnight 2 (Serv. 10-24 → Invoice 25-end)",
      "admin_year": "Year",
      "admin_month_of_payment": "Month (of payment)",
      "admin_period_summary": "Period summary:",
      "admin_services_period_short": "Services: {{range}}",
      "admin_billing_period_short": "Billing: {{range}}",
      "admin_payment_period_short": "Payment: {{range}}",
      "admin_billing_25_end": "25-end",
      "admin_generating": "Generating...",
      "admin_driver_liquidations_title": "Driver Liquidations",
      "admin_driver_liquidations_subtitle": "Manage driver payments and liquidations",
      "admin_generate_liquidations": "Generate Liquidations",
      "admin_generate_liquidations_desc": "Generate liquidations for the selected period. Only services with approved expenses will be included.",
      "admin_generation_stopped": "Generation stopped",
      "admin_generation_stopped_reason": "No liquidations were generated: {{reason}}",
      "admin_payment_periods": "Payment Periods",
      "admin_quincena_1_desc": "Fortnight 1: Services from 25th to 9th → Payment from 10th to 15th",
      "admin_quincena_2_desc": "Fortnight 2: Services from 10th to 24th → Payment from 25th to last day",
      "admin_only_approved_expenses": "Only services with approved expenses are included",
      "admin_pending_expense_approval_count": "{{count}} service(s) pending expense approval",
      "admin_pending_expense_reports": "Pending Expense Reports ({{count}})",
      "admin_approve_reject_expenses_desc": "Approve or reject expenses reported by drivers",
      "admin_no_pending_reports": "There are no pending reports for approval",
      "admin_billing_periods_title": "Billing Periods",
      "admin_billing_periods_subtitle": "Liquidations grouped by payment period",
      "admin_search_driver_placeholder": "Search driver...",
      "admin_loading_periods": "Loading periods...",
      "admin_in_progress": "IN PROGRESS",
      "admin_invoice_pending": "INVOICE PENDING",
      "admin_period_closed_ready_to_bill": "Period Closed, Ready to Bill",
      "admin_period_closed_generate_message": "This period has closed. Generate the settlements to process payments to drivers.",
      "admin_generate_settlements_first": "Generate settlements for this period first",
      "admin_billing_details": "Billing details",
      "admin_save_billing_data": "Save Data",
      "admin_realtime_accumulation": "Real-time accumulation",
      "admin_expected_payment": "Expected payment",
      "admin_services_count_label": "services",
      "admin_total_accumulated": "total accumulated",
      "admin_amounts_update_note": "Amounts update as expenses are approved. Liquidation is generated when the period is closed.",
      "admin_liquidated": "LIQUIDATED",
      "admin_driver_col": "DRIVER",
      "admin_supplies_col": "SUPPLIES",
      "admin_irpf_col": "INCOME TAX",
      "admin_status_col": "STATUS",
      "admin_no_drivers_match": "No drivers found with that name",
      "admin_no_approved_pending_liquidation": "There are no approved services pending liquidation",
      "admin_no_drivers_in_period": "No drivers in this period",
      "admin_reported_label": "Reported",
      "admin_expense_driver": "Driver",
      "admin_expense_fuel": "Fuel",
      "admin_expense_toll": "Tolls",
      "admin_expense_parking": "Parking",
      "admin_expense_taxi": "Taxi",
      "admin_expense_other": "Other",
      "admin_other_expenses_label": "Other expenses:",
      "admin_tickets_receipts": "Tickets and Receipts ({{count}})",
      "admin_ticket_label": "Ticket",
      "admin_approve_btn": "Approve",
      "admin_reject_btn": "Reject",
      "admin_reject_reason_prompt": "Rejection reason:",
      "admin_hide_services": "Hide services",
      "admin_view_services": "View services",
      "admin_payment_label": "Payment",
      "admin_approvals_subtitle": "Review and approve services completed by drivers",
      "admin_services_pending_approval_title": "Services Pending Approval",
      "admin_services_pending_approval_desc": "Services that have been completed and are awaiting approval",
      "admin_no_services_pending_approval": "There are no services pending approval",
      "admin_vehicle_label": "Vehicle",
      "admin_origin_label": "Origin",
      "admin_destination_label": "Destination",
      "admin_total_price_label": "Total Price",
      "admin_service_status_label": "Service Status",
      "admin_service_type_label": "Service Type",
      "admin_pending_approval_badge": "Pending Approval",
      "admin_photos_pickup_label": "Pickup Photos",
      "admin_photos_delivery_label": "Delivery Photos",
      "admin_expenses_label": "Expenses",
      "admin_view_photos_btn": "View Photos",
      "admin_profiles_title": "Profiles",
      "admin_profiles_subtitle": "View and manage client and driver profiles",
      "admin_profiles_subtitle_drivers_only": "View and manage your assigned drivers' profiles",
      "admin_profiles_clients_tab": "Client Profiles",
      "admin_profiles_drivers_tab": "Driver Profiles",
      "admin_clients_registered": "Registered Clients",
      "admin_create_client": "Create Client",
      "admin_create_new_client": "Create New Client",
      "admin_create_new_client_desc": "Create a new client. A password will be automatically generated and sent by email.",
      "admin_create_client_password_info": "A random password will be generated and sent to the client's email along with their access credentials.",
      "admin_search_client_placeholder": "Search by name, DNI/NIF/CIF/NIE or email...",
      "admin_no_clients_search": "No clients found matching your search",
      "admin_no_clients_registered": "No registered clients",
      "admin_cif_dni_label": "CIF/DNI:",
      "admin_phone_label": "Phone:",
      "admin_address_label": "Address:",
      "admin_country_label": "Country:",
      "admin_registered_label": "Registered:",
      "admin_rate_label": "Rate:",
      "admin_not_specified": "Not specified",
      "admin_not_specified_f": "Not specified",
      "admin_view_details": "View Details",
      "admin_search_driver_placeholder": "Search by name, DNI/NIE, license or email...",
      "admin_no_drivers_search": "No drivers found matching your search",
      "admin_no_drivers_registered": "No registered drivers",
      "admin_driver_dni_label": "DNI/NIF:",
      "admin_driver_status_label": "Status:",
      "admin_available": "Available",
      "admin_not_available": "Not available",
      "admin_edit": "Edit",
      "admin_view_more": "View more",
      "admin_driver_badge_validated": "✓ Validated",
      "admin_driver_badge_pending": "⏳ Pending",
      "admin_driver_badge_expires_soon": "⚠️ Expires Soon",
      "admin_driver_badge_no_docs": "❌ No Documents",
      "admin_edit_client": "Edit Client",
      "admin_edit_client_desc": "Modify client information. The admin can edit everything, including email.",
      "admin_company_logo": "Company Logo",
      "admin_upload_logo": "Upload Logo",
      "admin_uploading": "Uploading...",
      "admin_logo_hint": "PNG, JPG • Max 2MB",
      "admin_name_required": "Name *",
      "admin_email_required": "Email *",
      "admin_email_change_warning": "Changing the email will affect client access",
      "admin_company_name": "Company Name",
      "admin_cif_dni": "CIF/DNI",
      "admin_phone": "Phone",
      "admin_country": "Country",
      "admin_address": "Address",
      "admin_country_placeholder": "ES, FR, etc.",
      "admin_payment_type": "Payment Type",
      "admin_payment_biweekly": "Biweekly (Transfer)",
      "admin_payment_instant": "Instant Payment (Virtual POS)",
      "admin_payment_biweekly_desc": "Invoiced every 15 days and paid by bank transfer",
      "admin_payment_instant_desc": "Charged when creating or editing services via Santander Virtual POS",
      "admin_save_changes": "Save Changes",
      "admin_documents_drivers_title": "Driver Documents",
      "admin_documents_subtitle": "Review and validate documents uploaded by drivers",
      "admin_documents_pending_expired_title": "Pending and Expired Documents",
      "admin_documents_require_attention": "Total: {{count}} documents require attention",
      "admin_no_documents_pending": "No documents pending validation",
      "admin_document_label": "Document:",
      "admin_upload_date_label": "Upload date:",
      "admin_expiry_date_label": "Expiry date:",
      "admin_status_label": "Status:",
      "admin_status_expired": "⚠️ Expired",
      "driver_name_label": "Name",
      "driver_phone_label": "Phone",
      "driver_not_specified": "Not specified",
      "driver_type_label": "Type",
      "driver_fleet_member": "Fleet Member",
      "driver_independent": "Independent Driver",
      "driver_doc_status": "Document Status",
      "driver_docs_loading": "Loading documents...",
      "driver_documents": "Documents",
      "driver_view": "View",
      "driver_download": "Download",
      "driver_preview_title": "Preview",
      "driver_view_doc_tooltip": "View document in new tab",
      "driver_download_doc_tooltip": "Download document",
      "driver_delete_doc_tooltip": "Delete document",
      "driver_expires": "Expires:",
      "driver_bank_account": "Bank Account",
      "driver_tax_id": "Tax ID",

      // Messages
      "order_created": "Order created successfully!",
      "order_updated": "Order updated successfully!",
      "payment_success": "Payment completed successfully!",
      "payment_failed": "Payment failed. Please try again.",
      "error_occurred": "An error occurred. Please try again.",
      "auth_callback_no_session_id": "No session ID found",
      "address_toast_selected": "✓ Address selected successfully",
      "address_toast_no_coords": "Could not get coordinates for this address",
      "address_toast_init_error": "Error initializing autocomplete. Use the city buttons.",
      "address_toast_city_selected": "✓ City selected: {{city}}",
      "address_toast_coords_set": "✓ Coordinates set successfully",
      "address_toast_invalid_coords": "Invalid coordinates. Lat: -90 to 90, Lng: -180 to 180",
      "address_toast_coords_extracted": "✓ Coordinates extracted from Google Maps link",
      "address_toast_coords_extract_error": "Could not extract coordinates from link",
      "address_toast_select_suggestions": "Please select an address from the suggestions",
      "address_toast_error_get_details": "Error getting address details",
      "forgot_toast_success": "A recovery link has been sent to your email",
      "forgot_toast_error": "Error processing your request",
      "forgot_toast_error_send": "Error sending email",
      "forgot_toast_email_not_sent": "If your email is registered, we could not send the message. Please contact support.",
      "forgot_network_error": "Network error",
      "forgot_title": "Recover Password",
      "forgot_description": "Enter your email and we will send you instructions",
      "forgot_email_label": "Email Address",
      "forgot_email_placeholder": "your@email.com",
      "forgot_sending": "Sending...",
      "forgot_submit": "Send Recovery Link",
      "forgot_back_login": "Back to login",
      "change_password_mismatch": "Passwords do not match",
      "change_password_min_length": "Password must be at least 6 characters",
      "change_password_success": "Password updated successfully",
      "change_password_error": "Error changing password",
      "change_password_description": "Please set a new secure password",
      "change_password_btn": "Update Password",
      "change_password_updating": "Updating...",
      "admin_login_toast_success": "Login successful!",
      "admin_login_toast_error": "Invalid email or password",
      "admin_back_to_home": "Back to home",
      "admin_sign_in": "Sign in",
      "admin_signing_in": "Signing in...",
      "client_login_welcome": "Welcome!",
      "client_login_error": "Error signing in",
      "client_toast_no_session": "No active session. Please sign in again.",
      "client_toast_preparing_contract": "Preparing contract...",
      "client_toast_contract_generated": "Contract generated. If it doesn't download automatically, check your pop-up blocker.",
      "client_toast_error_download_contract": "Error downloading contract",
      "client_toast_error_load_invoices": "Error loading invoices",
      "client_toast_photos_pending_approval": "Photos are pending admin approval",
      "client_toast_photos_not_available": "Photos are not available yet",
      "client_toast_no_photos_yet": "No photos available yet",
      "client_toast_error_load_photos": "Error loading photos",
      "client_toast_no_expenses_yet": "No approved expenses yet",
      "client_toast_error_load_expenses": "Error loading expenses",
      "client_toast_error_load_completion": "Error loading completion details",
      "client_toast_distance_calculated": "Distance calculated: {{distance}} km - Price: €{{price}}",
      "client_toast_error_calculate_distance": "Error calculating distance",
      "client_toast_service_cancelled_fee": "Service cancelled: {{status}}. Charge: €{{fee}}",
      "client_toast_error_cancel_service": "Error cancelling service",
      "client_toast_price_updated": "Price updated",
      "client_toast_error_calculate_price": "Error calculating price",
      "client_toast_enter_valid_distance": "Enter a valid distance",
      "client_completion_waiting_extras": "Waiting time / Extras",
      "client_completion_extras_total": "Extras total (excl. VAT)",
      "service_toast_load_failed": "Could not load service",
      "service_toast_error_load": "Error loading service",
      "service_toast_updated": "Service updated successfully",
      "service_toast_error_update": "Error updating",
      "service_toast_error_update_service": "Error updating service",
      "service_toast_error_upload_file": "Error uploading {{fileName}}",
      "service_toast_photos_uploaded": "{{count}} photo(s) uploaded",
      "service_toast_error_upload_photos": "Error uploading photos",
      "service_toast_completed": "Service completed successfully",
      "service_toast_error_complete": "Error completing",
      "service_toast_error_complete_service": "Error completing service",
      "service_toast_reverted": "Service reverted successfully",
      "service_toast_error_revert": "Error reverting",
      "service_toast_error_revert_service": "Error reverting service",
      "service_toast_deleted": "Service deleted",
      "service_toast_error_delete": "Error deleting",
      "service_toast_error_delete_service": "Error deleting service",
      "service_toast_cancelled": "Service cancelled",
      "service_toast_error_cancel": "Error cancelling",
      "service_toast_error_cancel_service": "Error cancelling service",
      "service_toast_contract_downloaded": "Contract downloaded",
      "service_toast_error_generate_contract": "Error generating contract",
      "service_toast_error_download_contract": "Error downloading contract",
      "service_toast_opening_calendar": "Opening Google Calendar...",
      "driver_toast_contract_downloaded": "Contract downloaded successfully",
      "driver_toast_error_download_contract": "Error downloading contract",
      "driver_toast_error_load_drivers": "Error loading drivers",
      "driver_toast_driver_created": "Driver created. Documents pending admin approval.",
      "driver_toast_driver_created_with_password": "Driver created successfully. ⚠️ Temporary password: {{temp_password}}. Please share it with the driver.",
      "driver_toast_error_create_driver": "Error creating driver: {{message}}",
      "driver_error_create_driver_fallback": "Error creating driver",
      "driver_toast_driver_updated": "Driver updated successfully",
      "driver_toast_error_update_driver": "Error updating driver",
      "driver_toast_driver_deleted": "Driver deleted successfully",
      "driver_toast_error_delete_driver": "Error deleting driver",
      "driver_toast_service_assigned_self": "Service assigned to yourself.",
      "driver_toast_service_reassigned": "Service reassigned successfully. Email sent.",
      "driver_toast_service_assigned": "Service assigned successfully. Email sent.",
      "driver_toast_error_assign_service": "Error assigning service",
      "driver_toast_logged_out": "Logged out",
      "driver_toast_error_load_billing_periods": "Error loading billing periods",
      "driver_toast_error_load_period_details": "Error loading period details",
      "driver_toast_error_load_incomplete_services": "Error loading incomplete services",
      "driver_toast_complete_required_fields": "Please complete all required fields",
      "driver_toast_profile_updated": "Profile updated successfully",
      "driver_toast_new_iban_next_invoice": "The new account number will be used on your next invoice",
      "driver_toast_error_update_profile": "Error updating profile",
      "driver_toast_error_save_changes": "Error saving changes",
      "driver_toast_member_updated": "Member updated successfully.",
      "driver_toast_member_updated_with_docs": "Member updated successfully. {{count}} document(s) uploaded.",
      "driver_toast_error_update_member": "Error updating member",
      "driver_toast_select_file": "Please select a file",
      "driver_toast_document_uploaded": "Document uploaded successfully",
      "driver_toast_error_upload_document": "Error uploading document",
      "driver_toast_select_at_least_one_photo": "Select at least one photo",
      "driver_toast_pickup_photos_uploaded": "Pickup photos uploaded successfully",
      "driver_toast_error_upload_photos": "Error uploading photos",
      "driver_toast_error_upload_pickup_photos": "Error uploading pickup photos",
      "driver_toast_delivery_photos_uploaded": "Delivery photos uploaded successfully",
      "driver_toast_error_upload_delivery_photos": "Error uploading delivery photos",
      "driver_toast_select_contract_photo": "Select at least one contract photo",
      "driver_toast_contract_uploaded": "Contract uploaded successfully",
      "driver_toast_error_upload_contract": "Error uploading contract",
      "driver_toast_expense_report_sent": "Expense report sent successfully",
      "driver_toast_error_send_report": "Error sending report",
      "driver_toast_error_connection_expense_report": "Error connecting while sending expense report",
      "driver_toast_service_completed": "Service completed successfully",
      "admin_toast_error_load_photos": "Error loading photos",
      "admin_toast_error_load_expenses": "Error loading expenses",
      "admin_toast_failed_load_data": "Failed to load data",
      "admin_toast_error_load_billing": "Error loading billing data",
      "admin_toast_partial_load": "Some data could not be loaded. Refresh the page to try again.",
      "admin_toast_error_generate_liquidations": "Error generating liquidations",
      "admin_toast_error_generate_client_invoices": "Error generating client invoices",
      "admin_toast_excel_downloaded": "Excel downloaded",
      "admin_toast_error_download_excel": "Error downloading Excel",
      "admin_toast_error_load_period_details": "Error loading period details",
      "admin_toast_error_load_period_trips": "Error loading period trips",
      "admin_toast_driver_profile_incomplete": "Driver profile is incomplete. Please edit the driver and complete all billing fields (full name, ID, fiscal address, bank and account).",
      "admin_toast_error_generate_invoice": "Error generating invoice. Please ensure the driver has all billing details complete.",
      "admin_toast_select_charge_and_amount": "Select a charge type and enter the amount",
      "admin_toast_error_update_report": "Error updating report",
      "admin_toast_period_marked_paid": "Period marked as paid",
      "admin_toast_error_mark_period_paid": "Error marking period as paid",
      "admin_toast_failed_save_driver": "Failed to save driver",
      "admin_toast_driver_deleted": "Driver deleted successfully",
      "admin_toast_failed_delete_driver": "Failed to delete driver",
      "admin_toast_error_save_rate": "Error saving rate",
      "admin_toast_pricing_deleted": "Pricing deleted successfully",
      "admin_toast_failed_delete_pricing": "Failed to delete pricing",
      "admin_toast_error_save_service": "Error saving service",
      "admin_toast_service_deleted": "Service deleted successfully",
      "admin_toast_error_delete_service": "Error deleting service",
      "admin_toast_template_created": "Pricing template created successfully",
      "admin_toast_error_create_template": "Error creating template",
      "admin_toast_template_deleted": "Template deleted successfully",
      "admin_toast_error_delete_template": "Error deleting template",
      "admin_toast_rate_added": "Rate added successfully",
      "admin_toast_rate_deleted": "Rate deleted successfully",
      "admin_toast_error_delete_rate": "Error deleting rate",
      "admin_toast_rate_assigned": "Rate assigned to client successfully",
      "admin_toast_error_assign_rate": "Error assigning rate",
      "admin_toast_custom_rate_removed": "Custom rate removed. Client uses general rates.",
      "admin_toast_error_remove_assignment": "Error removing assignment",
      "admin_toast_client_updated": "Client updated successfully",
      "admin_toast_error_update_client": "Error updating client",
      "admin_toast_driver_updated": "Driver updated successfully",
      "admin_toast_error_open_document": "Error opening document",
      "admin_toast_error_view_document": "Error viewing document",
      "admin_toast_file_too_large": "File is too large. Maximum 5MB.",
      "admin_toast_invalid_format": "Invalid format. Only JPG, PNG or PDF allowed.",
      "admin_toast_license_expiry_required": "Please enter the license expiry date",
      "admin_toast_dni_expiry_required": "Please enter the ID expiry date",
      "admin_toast_client_created": "Client created successfully. Welcome email sent.",
      "admin_toast_client_created_no_email": "Client created successfully. Welcome email could not be sent; please share credentials manually.",
      "admin_toast_error_upload_photos": "Error uploading photos",
      "admin_toast_service_completed_historic": "Service completed and moved to history",
      "admin_toast_error_connection_complete": "Connection error while completing service",
      "admin_toast_error_revert_service": "Error reverting service",
      "admin_toast_error_load_service_details": "Error loading service details",
      "admin_toast_complete_pickup_delivery": "Please complete pickup and delivery addresses",
      "admin_toast_complete_vehicle_data": "Please complete vehicle data",
      "admin_toast_set_driver_price": "Please set the price for the driver",
      "admin_toast_logo_uploaded": "Logo uploaded successfully",
      "admin_toast_document_approved": "Document approved",
      "admin_toast_error_approve_document": "Error approving document",
      "admin_toast_document_rejected": "Document rejected. Email sent to driver.",
      "admin_toast_document_rejected_no_email": "Document rejected. Email could not be sent to driver.",
      "admin_toast_driver_created_no_email": "Driver created successfully. Welcome email could not be sent; share credentials manually.",
      "admin_toast_error_reject_document": "Error rejecting document",
      "admin_toast_select_rate_before_save": "You must select a rate for the driver (Basic, Premium, JLUIS or Custom) before saving",
      "admin_toast_complete_all_fields": "Please complete all fields",
      "admin_toast_invoice_uploaded": "Invoice uploaded successfully",
      "admin_toast_period_marked_paid_short": "Period marked as paid",
      "admin_toast_error_mark_period_paid": "Error marking period as paid",
      "admin_toast_invoice_deleted": "Invoice deleted successfully",
      "admin_toast_error_delete_invoice": "Error deleting invoice",
      "admin_toast_period_no_services": "Period has no associated services",
      "admin_toast_warning_period_no_services": "This period has no services",
      "admin_toast_warning_services_not_found": "Services for this period were not found in the database",
      "admin_toast_service_not_found": "Service not found",
      "admin_toast_service_no_distance": "Service has no distance defined",
      "admin_toast_service_no_type": "Service has no type defined",
      "admin_toast_error_calculate_prices": "Error calculating prices",
      "admin_toast_driver_docs_not_validated": "This driver does not have validated documents. Cannot assign services.",
      "admin_toast_enter_distance_before_assign": "Please enter the service distance before assigning a driver.",
      "admin_toast_select_service_type_before_assign": "Please select the service type before assigning a driver.",
      "admin_toast_templates_not_loaded": "Error: Pricing templates not loaded. Please refresh the page.",
      "admin_toast_could_not_calculate_rates": "Could not calculate rates.",
      "admin_toast_error_calculate_rates": "Error calculating rates",
      "admin_toast_error_calculate_price_message": "Error calculating price: {{message}}",
      "admin_toast_enter_distance_before_rate": "Please enter distance before selecting rate",
      "admin_toast_select_type_before_rate": "Please select service type before selecting rate",
      "admin_toast_could_not_calculate_price": "Could not calculate price. Check distance and service type.",
      "admin_toast_error_calculate_rate_message": "Error calculating rate: {{message}}",
      "admin_toast_rate_updated": "Rate updated successfully",
      "admin_toast_error_update_rate": "Error updating rate",
      "admin_toast_template_name_required": "Template name is required",
      "admin_toast_template_created_short": "Template created successfully",
      "admin_toast_contract_downloaded_2pages": "Contract downloaded - 2 pages: Driver and Client",
      "admin_confirm_delete_driver": "Are you sure you want to delete this driver?",
      "admin_confirm_delete_pricing": "Are you sure you want to delete this pricing rate?",
      "admin_confirm_delete_additional_service": "Are you sure you want to delete this additional service?",
      "admin_confirm_delete_template": "Delete this template and all its rates?",
      "admin_confirm_delete_rate": "Delete this rate?",
      "admin_confirm_remove_custom_rate": "Remove the custom rate from this client?",
      "admin_confirm_delete_service": "Are you sure you want to delete this service? This action cannot be undone.",
      "admin_confirm_revert_service": "Are you sure you want to revert this service to \"In Progress\"? Completion data (photos, expenses) will be kept.",
      "admin_confirm_delete_invoice": "Delete this invoice? The period will return to pending status.",
      "admin_confirm_cancel_order": "Are you sure you want to cancel this service?\n\nService: #{{serviceId}}\nClient: {{clientName}}\nDriver: {{driverName}}\n\nCancellation logic will be applied automatically:\n- Client: Charge based on time until pickup\n- Driver: Compensation based on time until pickup\n- Notification emails will be sent",
      "admin_confirm_cancel_at_pickup": "⚠️ CANCELLED AT PICKUP\n\nIs the vehicle NOT available at pickup time?\n\nService: #{{serviceId}}\nClient: {{clientName}}\nDriver: {{driverName}}\n\nIMPORTANT:\n- Client: FULL charge (100%)\n- Driver: FULL payment (100%)\n- Moves to HISTORY automatically\n- Notification emails will be sent",
      "admin_confirm_cancel_in_transit": "⚠️ CANCELLED IN TRANSIT\n\nWas the service cancelled during the journey?\n\nService: #{{serviceId}}\nClient: {{clientName}}\nDriver: {{driverName}}\n\nPROCESS:\n1. Service moves to PENDING\n2. Driver must upload: Expenses, Pickup photos, Photos of where vehicle was left\n3. You must APPROVE the documentation\n4. Once approved: Client pays 100%, Driver receives 100%, Moves to HISTORY",
      "admin_confirm_approve_transit": "✅ APPROVE TRANSIT CANCELLATION\n\nHave you reviewed the driver's documentation?\n\nService: #{{serviceId}}\nDriver: {{driverName}}\n\nOn approval: Client will pay 100%, Driver will receive 100%, Service will move to HISTORY, Will be included in billing",
      "service_confirm_revert": "Are you sure you want to revert this service?",
      "service_confirm_delete": "Are you sure you want to DELETE this service? This action cannot be undone.",
      "driver_confirm_delete_member": "Delete driver {{name}}?",
      "driver_doc_confirm_delete": "Are you sure you want to delete this document?",
      "driver_doc_alert_connection_error": "Connection error while opening document",
      "driver_doc_alert_download_error": "Error downloading document",
      "driver_doc_alert_deleted": "Document deleted successfully",
      "driver_doc_alert_error_delete": "Error deleting document",
      "driver_doc_alert_uploaded": "Document uploaded successfully",
      "driver_doc_alert_error_upload": "Error uploading document",
      "driver_doc_alert_error_upload_detail": "Error uploading document: {{detail}}",
      "service_status_undefined": "Not set",
      "service_status_not_calculated": "Not calculated",
      "service_status_pending": "Pending",
      "service_status_assigned": "Assigned",
      "service_status_in_progress": "In Progress",
      "service_status_in_transit": "In Transit",
      "service_status_delivered": "Delivered",
      "service_status_cancelled": "Cancelled",
      "service_no_client": "No client",
      "service_no_driver": "Unassigned",
      "service_no_plate": "No plate",
      "driver_no_orders": "You have no assigned services yet",
      "driver_no_orders_filter": "No services found with the applied filters",
      "driver_date_unspecified": "Not specified",
      "driver_pending_approval": "Pending Approval",
      "driver_complete_service": "Complete Service",
      "driver_not_specified": "Not specified",
      "driver_available": "Available",
      "driver_not_available": "Not Available",
      "driver_saving": "Saving...",
      "driver_edit_click_hint": "Click \"Edit\" to update your information.",
      "driver_status_rejected": "Rejected",
      "driver_send_expense_report": "Send Expense Report",
      "driver_sending": "Sending...",
      "address_toast_selected": "Address selected successfully",
      "common_document_preview": "Document Preview",
      "ph_description": "Description",
      "ph_observations_delivery": "Observations about delivery...",
      "ph_email_example": "admin@example.com",
      "ph_enter_password": "Enter your password",
      "ph_email_driver": "your@email.com",
      "ph_password_dots": "••••••••",
      "ph_new_password_placeholder": "Enter your new password",
      "ph_city_search": "Type a city...",
      "ph_vehicle_address": "Address where the vehicle is located",
      "ph_phone_es": "+34 600 123 456",
      "ph_distance_example": "e.g. 150.5",
      "title_download": "Download",
      "title_pdf_viewer": "PDF Viewer",
      "ph_company_example": "e.g. Acme Transport S.L.",
      "ph_select_country": "Select country",
      "ph_name_example": "e.g. John Smith",
      "ph_lat_example": "Latitude (e.g. 41.3851 for Barcelona)",
      "ph_lon_example": "Longitude (e.g. 2.1734 for Barcelona)",
      "ph_cities_search": "Madrid, Barcelona...",
      "ph_brands": "Toyota, BMW...",
      "ph_models": "Corolla, Series 3...",
      "ph_plate_example": "1234ABC",
      "ph_fullname_example": "e.g. John Smith",
      "ph_dni_example": "12345678A",
      "ph_number_short": "15",
      "ph_fiscal_address": "Street, number, postcode, city, province",
      "ph_city_example": "e.g. London",
      "ph_iban_example": "ES00 0000 0000 0000 0000 0000",
      "ph_describe_expense": "Describe the expense",
      "ph_select_client": "Select client",
      "ph_select_client_alt": "Select a client",
      "ph_notes_service": "Add notes or comments about this service...",
      "ph_amount": "0.00",
      "ph_optional": "Optional",
      "ph_no_client_admin": "No client (Admin)",
      "ph_search_pickup": "Search pickup address...",
      "ph_search_delivery": "Search delivery address...",
      "ph_name": "Name",
      "ph_invoice_ref": "e.g. 2025/001",
      "ph_no_driver_pending": "Unassigned (pending)",
      "ph_special_instructions": "Special instructions, notes...",
      "ph_toll_example": "e.g. Urban toll, etc.",
      "ph_time_example": "e.g. 30 minutes",
      "ph_notes_delivery_optional": "Add notes about delivery (optional)...",
      "title_edit_service": "Edit service",
      "title_mark_paid": "Mark as paid",
      "title_approve_driver": "Approve driver",
      "title_view_profile": "View full profile",
      "title_view_details": "View details",
      "title_download_excel": "Download Excel",
      "title_download_pdf": "Download PDF",
      "title_generate_invoice_pdf": "Generate Invoice PDF",
      "ph_address_maps": "💡 Type address, select suggestions or paste a Google Maps link",
      "ph_phone_admin": "+34 600 000 000",
      "ph_qty": "Qty",
      "ph_price": "Price",
      "ph_extra_description": "Custom extra description...",
      "ph_search_vehicle": "Brand, model, plate...",
      "ph_price_eur": "Price in €",
      "ph_brand_toyota": "Toyota",
      "ph_model_corolla": "Corolla",
      "ph_plate_short": "1234ABC",
      "ph_color_example": "e.g. White",
      "ph_year_example": "2023",
      "ph_zero": "0",
      "ph_rate_040": "0.40",
      "ph_rate_032": "0.32",
      "ph_rate_028": "0.28",
      "aria_select_language": "Select language",
      "aria_pagination": "pagination",
      "aria_prev_page": "Go to previous page",
      "aria_next_page": "Go to next page",
      "aria_breadcrumb": "breadcrumb",
      "common_previous": "Previous",
      "common_next": "Next",
      "common_close": "Close",
      "period_trips_title": "Travel Details",
      "period_trips_total_trips": "Total Trips",
      "period_trips_income": "Income",
      "period_trips_expenses": "Expenses",
      "period_trips_total_vat": "Total with VAT",
      "period_trips_loading": "Loading trips...",
      "period_trips_empty": "No trips in this period.",
      "period_trips_expenses_approved": "✓ Expenses Approved",
      "period_trips_vehicle": "Vehicle:",
      "period_trips_plate": "License plate:",
      "period_trips_client": "Client:",
      "period_trips_pickup_date": "Pickup date:",
      "period_trips_delivery_date": "Delivery date:",
      "period_trips_service": "Service:",
      "period_trips_route": "Route:",
      "period_trips_driver_rate": "Driver rate",
      "period_trips_supplied_expenses": "Supplied expenses",
      "period_trips_total_service": "Total service",
      "period_trips_fuel": "Fuel:",
      "period_trips_tolls": "Tolls:",
      "period_trips_parking": "Parking:",
      "period_trips_taxi": "Taxi:",
      "period_trips_other": "Other:",
      "period_status_completed": "Completed",
      "period_label_period": "Period:",
      "driver_nav_home": "Home",
      "driver_nav_services": "Services",
      "driver_nav_complete": "Complete",
      "driver_nav_profile": "My Profile",
      "driver_nav_billing": "Billing",
      "driver_nav_fleet": "My Fleet",
      "driver_docs_pending_title": "Pending Documentation",
      "driver_docs_pending_text": "You must upload and validate all required documents to receive service assignments.",
      "driver_loading": "Loading...",
      "calendar_scheduled_subtitle": "Your scheduled services",
      "driver_active_services": "Active services",
      "driver_from_n_services": "From {{count}} services",
      "driver_validation_progress": "Validation progress ({{uploaded}}/7 uploaded)",
      "driver_this_week_n_services": "This week ({{count}} services)",
      "driver_status_services": "Service Status",
      "driver_status_documents": "Document Status",
      "driver_trend_title": "Service and Revenue Trend",
      "driver_trend_subtitle": "Last 6 months",
      "driver_recent_services": "Recent Services",
      "driver_last_5_assigned": "Last 5 assigned services",
      "calendar_day": "Day",
      "calendar_week": "Week",
      "calendar_month": "Month",
      "calendar_legend_assigned": "Assigned",
      "calendar_legend_completed": "Completed",
      "calendar_legend_today": "Today",
      "driver_completed_count": "{{count}} completed",
      "driver_chart_completed": "Services Completed",
      "driver_chart_income": "Income",
      "driver_chart_approved": "Approved",
      "driver_chart_rejected": "Rejected",
      "driver_chart_missing": "Missing",
      "driver_chart_cancelled": "Cancelled",
      "driver_date_unavailable": "Date unavailable",
      "calendar_origin": "Origin:",
      "calendar_destination": "Destination:",
      "calendar_view_full_details": "View full details",
      "calendar_no_services": "No services",
      "calendar_no_services_this_day": "No services scheduled for this day",
      "driver_validated": "Validated",
      "driver_commission": "Commission",
      "driver_services_title": "Services",
      "driver_services_subtitle": "Manage your active and historical trips",
      "driver_services_in_progress": "In progress",
      "driver_services_historical": "Historic",
      "driver_filters_title": "Search Filters",
      "driver_clear": "Clear",
      "driver_clear_filters": "Clear filters",
      "driver_search_address": "Search Address/City",
      "driver_status": "Status",
      "driver_all": "All",
      "driver_driver_label": "Driver",
      "driver_myself": "Myself",
      "driver_vehicle_brand": "Vehicle Brand",
      "driver_vehicle_model": "Vehicle Model",
      "driver_plate": "License Plate",
      "driver_fuel_type": "Fuel Type",
      "driver_fuel_gasoline": "Gasoline",
      "driver_fuel_diesel": "Diesel",
      "driver_fuel_electric": "Electric",
      "driver_fuel_hybrid": "Hybrid",
      "driver_payment_status": "Payment Status",
      "driver_paid": "Paid",
      "driver_unpaid": "Unpaid",
      "driver_showing_services": "Showing {{shown}} of {{total}} services",
      "driver_table_date": "Date",
      "driver_table_trip": "Trip",
      "driver_table_vehicle": "Vehicle",
      "driver_table_price": "Price",
      "driver_table_status": "Status",
      "driver_table_actions": "Actions",
      "driver_details": "Details",
      "driver_overdue_banner": "Delivery date passed - Complete service urgently",
      "driver_origin_short": "Origin",
      "driver_destination_short": "Destination",
      "driver_service_type_delivery": "Delivery",
      "driver_label_remuneration": "Remuneration",
      "driver_label_distance": "Distance",
      "driver_label_vehicle": "Vehicle",
      "driver_pickup": "PICKUP",
      "driver_delivery": "DELIVERY",
      "driver_incomplete_title": "Incomplete Services",
      "driver_incomplete_subtitle": "These services are delivered but need vehicle photos and expense report before the period closes",
      "driver_loading_services": "Loading services...",
      "driver_all_services_completed": "All services are completed!",
      "driver_no_pending_complete": "No pending services to complete",
      "driver_rejected": "Rejected",
      "driver_service_id": "Service ID",
      "driver_date_pickup": "Pickup Date",
      "driver_date_delivery_label": "Delivery Date",
      "driver_pending_approval_message": "This service is pending approval by the administrator. Once approved, it will be automatically added to your billing.",
      "driver_rejection_reason": "Rejection reason:",
      "driver_reupload_photos_expenses": "Please re-upload the photos and/or expenses correctly.",
      "driver_missing_pickup_photos": "Missing pickup photos",
      "driver_pickup_photos_uploaded": "Pickup photos uploaded",
      "driver_missing_delivery_photos": "Missing delivery photos",
      "driver_delivery_photos_uploaded": "Delivery photos uploaded",
      "driver_missing_expense_report": "Missing expense report",
      "driver_expense_reported": "Expenses reported",
      "driver_profile_title": "My Profile",
      "driver_profile_subtitle": "Driver personal information",
      "driver_label_name": "Name",
      "driver_label_phone": "Phone",
      "driver_label_dni": "DNI/NIF",
      "driver_label_status": "Status",
      "driver_status_available": "Available",
      "driver_status_not_available": "Not Available",
      "driver_doc_validation": "Document Validation",
      "driver_validation_pending": "Validation Pending",
      "driver_billing_title": "Billing Information",
      "driver_billing_description": "This information is used to generate your invoices",
      "driver_billing_full_name": "Full Legal Name",
      "driver_billing_dni": "DNI/NIE",
      "driver_billing_irpf": "IRPF Withholding (%)",
      "driver_billing_fiscal_address": "Full Tax Address",
      "driver_billing_bank": "Bank",
      "driver_billing_iban": "Account Number (IBAN)",
      "driver_billing_iban_note": "Account change will apply to your next invoice",
      "driver_billing_incomplete_warning": "To generate your invoices, you need to complete all billing fields. Click \"Edit\" to update your information.",
      "driver_my_documents": "My Documents",
      "driver_docs_progress": "Progress: {{uploaded}} of {{total}} documents uploaded",
      "driver_upload_document": "Upload Document",
      "driver_doc_license_front": "Driver's License (Front)",
      "driver_doc_license_back": "Driver's License (Back)",
      "driver_doc_dni_front": "ID/NIE (Front)",
      "driver_doc_dni_back": "ID/NIE (Back)",
      "driver_doc_autonomo": "Self-Employed Registration",
      "driver_doc_hacienda": "Tax Authority Current Account",
      "driver_doc_ss": "Social Security Current Account",
      "driver_doc_uploaded": "Uploaded:",
      "driver_doc_expires": "Expires:",
      "driver_doc_not_uploaded": "Not uploaded",
      "driver_update": "Update",
      "driver_doc_status_pending": "Pending",
      "driver_doc_status_approved": "Approved",
      "driver_doc_status_expired": "Expired",
      "driver_fleet_docs_title": "My Drivers' Documents",
      "driver_fleet_validated": "✓ Validated",
      "driver_billing_my_settlements": "My Settlements",
      "driver_billing_subtitle": "Bi-weekly payment periods with full breakdown",
      "driver_billing_periods_info": "Payment periods: Fortnight 1 (services 25-9, payment 10-15) • Fortnight 2 (services 10-24, payment 25-last)",
      "driver_billing_current_no_services": "Current Period: No services",
      "driver_billing_current_no_services_desc": "You have no approved services in the current period. When you complete services and they are approved, they will appear here.",
      "driver_billing_previous_periods": "Previous Periods",
      "driver_billing_no_previous": "There are no previous settlements",
      "driver_billing_no_previous_desc": "When a period closes and your services are settled, they will appear here",
      "driver_billing_loading_settlements": "Loading settlements...",
      "driver_billing_loading_period": "Loading current period...",
      "driver_billing_in_progress": "IN PROGRESS",
      "driver_billing_fortnight_1": "Fortnight 1",
      "driver_billing_fortnight_2": "Fortnight 2",
      "driver_billing_payment_label": "Payment:",
      "driver_billing_services": "Services",
      "driver_billing_base": "Base",
      "driver_billing_iva": "VAT (21%)",
      "driver_billing_supplies": "Supplies",
      "driver_billing_irpf_label": "IRPF",
      "driver_billing_total_accumulated": "TOTAL ACCUMULATED",
      "driver_billing_fleet_breakdown": "Breakdown by Fleet Driver:",
      "driver_billing_trips": "trips",
      "driver_billing_hide_services": "▲ Hide Services",
      "driver_billing_view_services": "▼ View Services ({{count}})",
      "driver_billing_totals": "Totals:",
      "driver_billing_driver": "Driver",
      "driver_billing_rate": "Rate",
      "driver_billing_paid": "✓ Paid",
      "driver_billing_period_breakdown": "Breakdown by driver:",
      "driver_billing_services_count": "service(s)",
      "driver_billing_view_services_btn": "View Services",
      "driver_billing_download_invoice": "Download Invoice",
      "driver_billing_period_details_title": "Billing Period Details",
      "driver_billing_period_label": "Period:",
      "driver_billing_total_trips": "Total Trips",
      "driver_assign_driver": "Assign Driver",
      "driver_reassign_driver": "Reassign Driver",
      "driver_urgent": "URGENT!",
      "driver_fleet_manage_subtitle": "Manage your fleet drivers",
      "driver_fleet_members_title": "Fleet Drivers",
      "driver_fleet_members_count": "{{count}} driver in your fleet",
      "driver_fleet_members_count_plural": "{{count}} drivers in your fleet",
      "driver_fleet_no_members": "No drivers in your fleet",
      "driver_fleet_add_to_start": "Add drivers to start managing your fleet",
      "driver_fleet_add_first": "Add First Driver",
      "driver_label_phone_short": "Phone:",
      "driver_label_license_no": "License No.:",
      "driver_status_busy": "Busy",
      "driver_status_disconnected": "Disconnected",
      "driver_label_documents": "Documents:",
      "driver_expense_details_title": "Expense Details",
      "driver_view_more": "View More",
      "driver_expense_fuel": "Fuel",
      "driver_expense_tolls": "Tolls",
      "driver_expense_tickets": "Tickets and Receipts",
      "driver_expenses_label": "Expenses",
      "driver_uploading": "Uploading...",
      "driver_upload_btn": "Upload",
      "driver_dialog_add_fleet_title": "Add Driver to Fleet",
      "driver_dialog_add_fleet_desc": "Create a new driver in your fleet.",
      "driver_dialog_basic_info": "Basic Information",
      "driver_dialog_full_name": "Full Name",
      "driver_dialog_license_no": "Driver's License No.",
      "driver_dialog_password_note": "📧 Note: A temporary password will be generated and sent by email to the driver along with their access credentials.",
      "driver_dialog_docs_optional": "Documents (Optional)",
      "driver_dialog_docs_later": "You can upload documents now or the driver can upload them later from their portal.",
      "driver_dialog_create_driver": "Create Driver",
      "driver_dialog_edit_fleet_title": "Edit Fleet Driver",
      "driver_dialog_edit_fleet_desc": "Update the driver information and upload documents.",
      "driver_dialog_driver_available": "Driver available to receive services",
      "driver_save_changes": "Save Changes",
      "driver_close": "Close",
      "driver_select_driver": "Select Driver",
      "driver_upload_pickup_photos": "Upload {{count}} Pickup Photo(s)",
      "driver_upload_delivery_photos": "Upload {{count}} Delivery Photo(s)",
      "driver_upload_contract_photos": "Upload {{count}} Contract Photo(s)",
      "placeholder_select_driver": "Select driver",
      "placeholder_amount": "0.00",
      "admin_toast_service_approved_completed": "Service approved and moved to Completed",
      "admin_toast_error_approve_service": "Error approving service",
      "admin_toast_service_approved": "Service approved successfully",
      "admin_toast_service_rejected": "Service rejected",
      "admin_toast_error_reject_service": "Error rejecting service",
      "admin_toast_driver_approved": "Driver approved successfully",
      "admin_toast_error_approve_driver": "Error approving driver",
      "admin_toast_complete_distance_and_type": "Complete distance (km) and service type first to calculate rate",
      "admin_toast_template_basic_not_found": "Basic template not found",
      "admin_toast_template_premium_not_found": "Premium template not found",
      "admin_toast_template_jluis_not_found": "JLUIS template not found",
      "admin_toast_enter_valid_price": "Enter a valid price",
      "admin_toast_select_extra_type": "Select an extra type",
      "admin_toast_price_must_be_positive": "Price must be greater than 0",
      "admin_toast_extra_added": "Extra added",
      "admin_toast_could_not_calculate_rate": "Could not calculate rate",
      "admin_toast_error_calculate_price_short": "Error calculating price",
      "login_successful": "Login successful!",
      "logout_successful": "Logged out successfully",
      "invalid_credentials": "Invalid credentials",
      "driver_login_welcome": "Welcome!",
      "driver_login_error": "Invalid email or password",
      "driver_forgot_success": "A new password has been sent to your email",
      "driver_forgot_email_not_sent": "If your email is registered, we could not send the message. Please contact support.",
      "driver_forgot_error": "Could not send recovery email",
      "driver_forgot_send_error": "Error sending email",
      "driver_forgot_description": "Enter your email and we will send you a new password.",
      "driver_forgot_submit": "Send",
      "reset_toast_invalid_token": "Invalid recovery token",
      "reset_toast_password_requirements": "Password does not meet security requirements",
      "reset_toast_error": "Error resetting password",
      "reset_toast_success": "Password reset successfully",
      "reset_title": "Reset Password",
      "reset_description": "Enter your new password",
      "reset_new_password": "New Password",
      "reset_confirm_password": "Confirm Password",
      "reset_requirements_title": "Password requirements:",
      "reset_req_min_length": "Minimum 8 characters",
      "reset_req_uppercase": "At least one uppercase letter",
      "reset_req_number": "At least one number",
      "reset_req_symbol": "At least one symbol (!@#$%^&*)",
      "reset_passwords_match": "Passwords match",
      "reset_resetting": "Resetting...",
      "reset_submit": "Reset Password",
      "reset_back_login": "Back to login",
      "driver_reset_description": "Driver - Enter your new password",
      "reset_network_error": "Network error",
      "fill_required_fields": "Please fill in all required fields",
      "address_required": "Please select a valid address",
      "distance_calculating": "Calculating distance automatically...",
      
      // Auth Pages
      "welcome_back": "Welcome Back",
      "sign_in_to_manage": "Sign in to manage your transport services",
      "email_address": "Email Address",
      "email_placeholder": "you@email.com",
      "password": "Password",
      "password_placeholder": "Enter your password",
      "forgot_password": "Forgot your password?",
      "sign_in": "Sign In",
      "no_account": "Don't have an account? Contact the administrator:",
    }
  }
};

// Add Spanish translations for auth pages
resources.es.translation.welcome_back = "Bienvenido de Nuevo";
resources.es.translation.sign_in_to_manage = "Inicia sesión para gestionar tus servicios de transporte";
resources.es.translation.email_address = "Correo Electrónico";
resources.es.translation.email_placeholder = "tu@email.com";
resources.es.translation.password = "Contraseña";
resources.es.translation.password_placeholder = "Enter your password";
resources.es.translation.forgot_password = "¿Olvidaste tu contraseña?";
resources.es.translation.sign_in = "Iniciar Sesión";
resources.es.translation.no_account = "¿No tienes cuenta? Contacta con el administrador:";
resources.es.translation.driver_portal = "Portal de Conductores";
resources.es.translation.sign_in_to_view_services = "Inicia sesión para ver tus servicios asignados";
resources.es.translation.back_to_home = "Volver al inicio";
resources.es.translation.driver_access = "Acceso Conductor";

// Add English translations for driver login
resources.en.translation.driver_portal = "Driver Portal";
resources.en.translation.sign_in_to_view_services = "Sign in to view your assigned services";
resources.en.translation.back_to_home = "Back to Home";
resources.en.translation.driver_access = "Driver Access";

// Get saved language from localStorage or default to 'es'
// Normalize to 'es' or 'en' so it matches our resources
const stored = localStorage.getItem('i18nextLng') || 'es';
const savedLanguage = stored.startsWith('en') ? 'en' : 'es';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    },
    react: {
      bindI18n: 'languageChanged',
      useSuspense: false
    }
  });

// Save language to localStorage whenever it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;